import React, { Component } from 'react';
import {
  View,
  Text,
  ScrollView,
  TouchableHighlight,
  TextInput,
  Clipboard,
  Dimensions,
  Platform,
  Image,
  Alert,
  Linking,
  ActivityIndicator,
} from 'react-native';
import {StyleContext} from '../styleC';
import MavMiniButton from './mavMiniButton';
import MavViewMore from './mavViewMore';
import MavInfoBubble from './mavInfoBubble';
import CommonActions from "./CommonActions";
import Trajet from "./trajet"; 
import Clients from './clients';
import MavAlert from './mavAlert';
import firebase from './firebase';
import { getAuth, onAuthStateChanged, createUserWithEmailAndPassword,sendPasswordResetEmail, signInWithEmailAndPassword, EmailAuthProvider, reauthenticateWithCredential, updatePassword, deleteUser} from "firebase/auth";
import { getDatabase, ref, set, update, remove, get, onValue, child} from "firebase/database";
import { getStorage, ref as refStorage, uploadBytes, getDownloadURL } from "firebase/storage";
import strings from '../strings';
import example from '../example';
import Modal from './modal';
import MavTextInput from './mavTextInput';
import moneyList from '../moneyList';
import MavButton from './mavButton';
import info from '../info';
import countryList from '../countryList';
import MavNavigationMinimize from './mavNavigationMinimize';
const timer = require('react-native-timer');


import RNFetchBlob from './RNFetchBlob';

export default class account extends Component {
  constructor(props) {
    super(props);
    var params=(this.props.route!=undefined)?this.props.route.params:this.props.params; 

    var priList={}
    var taxiMode=false; 
    if(params!=undefined && params.pricingInfo!=undefined){
      var r=Object.keys(params.pricingInfo)

      var i;
      for(i=0;i<r.length;i++){
        if(params.pricingInfo[r[i]].type!="forfait") {
          var name=params.pricingInfo[r[i]].name;
          if(params.pricingInfo[r[i]].taxiMode==true) { name="TAXI - "+name; taxiMode=true} 
          priList[r[i]]={text:name}
        }
      }

      
    }

    var phoneInfo=this.findPhoneIID();


    this.state = {
      viewMode:"normal", 
      managerLock:(params.manager==true)?true:false,
      vipMode:(params!=undefined && params.vipMode!=undefined)?params.vipMode:false,
      defineColorForCustomer:(params!=undefined && params.defineColorForCustomer!=undefined)?params.defineColorForCustomer:false,
      params:params,
      taxiMode:taxiMode,
      name: '',
      lastName: '',
      enterprise:'',
      adressBill:'',
      cityBill:'',
      email: '',
      evtc:'',
      ntaxi:"",
      nloti:"",
      phone: '',
      password: '',
      clientID:'',
      vip:false, 
      favForbidden:false,
      emailHasChanged: false,
      countryPhone:phoneInfo.id,
      flagPhone:phoneInfo.flag,
      countryPhoneIID:phoneInfo.idd,
      manualClient:false,
      cguAgree:false,
      disableNavigation:(params!=undefined && params.disableNavigation==true && Platform.OS=="web")?true:false,
      adminView:(params!=undefined && params.adminView===true)?true:false,
      options:(params!=undefined && params.options!=undefined)?params.options:{},
      acceptedOptions:{},
      waiting:false,
      newClient:(params!=undefined && params.newClient===true)?true:false,
      createAccount:(params!=undefined && params.createAccount===true)?true:false,
      usersMoreInfos:"", 
      usersMoreInfosDriver:"",
      usersMoreInfosDriverSave:"",
      usersMoreInfosSave:"",
      accountClientDisabled:false,
      driverPricing:(params!=undefined && params.driverPricing===true)?true:false,
      partnerWrite:false,
      admin:false,
      driverAppli:false, 
      adminNotRace:false, 
      adsNotification:true,
      adsNotificationOld:true,
      partner:false,
      adress:"", 
      oldPartner:false, 
      customerPro:false,
      manager:false,
      managerInfo:{},
      billMode:"appCompany",
      privilegeProvider:"basic",
      tvaAdmission:false,
      partnerCompanyWithCommission:false,
      forceTVAPercent:false,
      companyBrand:"",
      companyAdress:"",
      companyCity:"",
      companyEmail:"",
      companyName:"",

      rcs:"",
      providerCommission:"",
      carModalVisible:false,
      tvaNumber:"",
      noVAT:false,
      assuranceName:"",
      assuranceNumber:"",
      privilegeDriver:"basic",
      viewPhone:"never",
      companySiret:"",
      car:{brand:"",model:"",immatriculation:"",chassis:""},
      carList:{},
      appliLastVersion:0,
      commission:"",
      tvaPercentClassic:"",
      tvaPercentDispo:"",
      blackList:[],
      clientList:[],
      partnerList:[],
      carModel:{},
      partnerListAccount:[{id:-1,text:strings.noFavoriteDriver}],
      partnerSelected:{id:-1,text:strings.noFavoriteDriver},
      noZone:{},
      noLanguage:{},
      pricingList:priList,
      permananteReduction:"",
      deferredPayment:false,
      globalUser:true,
      carID:"",
      waitingPicture:false,
      disabledChange:(params!=undefined && params.disabledChange===true)?true:false,
      autorizeChangeDriverFavoritePrice:(params!=undefined && params.autorizeChangeDriverFavoritePrice===true)?true:false,

    };








  }


  findPhoneIID(test){
    if(test!=undefined) test=test.replace("+","00")
    var final="";
    var i,j;
    var n;
    var list=Object.keys(countryList);
    for(i=0;i<list.length;i++){
      if(final==""){
          var testList=countryList[list[i]].list;
          for(j=0;j<testList.length;j++){ 
            if(test!=undefined){
              n=testList[j].idd.replace("+","00")
              n=test.search(n)
              if(n==0) final=testList[j]
            }
            else if(testList[j].id==info.countryCode) final=testList[j]
          }
      }
    }
    if(final=="") return {id:"fr",code:"+33"}
    else return {id:final.id,idd:final.idd, flag:final.flag}
    
  }



  getAllCar(){

    get(child(ref(getDatabase(firebase)), '/pricing')).then(value => {
      var val1=value.val();
      var val1array=Object.keys(val1)
      

      get(child(ref(getDatabase(firebase)), '/pricingProvision')).then(value2 => {
        var val2=value2.val();
        
        var carList={};
        var i,j,pr,pra;
        if(val1!=null){
          for(i=0;i<val1array.length;i++){
              pr=val1[val1array[i]].price;
              pra=Object.keys(pr)
              for(j=0;j<pra.length;j++){
                  var name=pr[pra[j]].name;

                  if(val1[val1array[i]].taxiMode==true) name="TAXI - "+name;
                  carList[name]=false;
              } 
          }

        }
        if(val2!=null){
          var val2array=Object.keys(val2)
          for(i=0;i<val2array.length;i++){
            if(val2array[i]=="typeZone"){
                  var k,l;
                  var tttot=val2[val2array[i]]; 
                  for(k=0;k<tttot.length;k++){
                      var listTttot=Object.keys(tttot[k].price)
                      for(l=0;l<listTttot.length;l++){
                          carList[tttot[k].price[listTttot[l]].name]=false
                      }
                  }
              }
              else{
                  carList[val2[val2array[i]].name]=false;
              }
            }  
        }
        
        var allCar=this.state.carList
        if(allCar!={}){
          var cla=Object.keys(this.state.carList);
          for(i=0;i<cla.length;i++){
            if(carList[cla[i]]!=undefined) carList[cla[i]]=allCar[cla[i]]
          }
        }

        this.setState({carList:carList})

       }) 

     }) 

  }

  searchNote(id){

    get(child(ref(getDatabase(firebase)), '/reviews/users/'+id+"/infos")).then(value => {

      var val=value.val()
      if(val!=null){
        this.setState({note:val})
      }

    })
  }

  changeCustomerColor= (value) => {
      
      this.setState({colorCustomer:value})
  }

  componentDidMount(){


      if(this.state.adminView==true) {

        if(this.state.defineColorForCustomer==true) {
          var clientID=(this.state.params.findClientById!=undefined)?this.state.params.findClientById:this.state.params.clientInfo.clientID

          if(clientID!=undefined) get(child(ref(getDatabase(firebase)), '/usersColor/'+clientID)).then(value => {var val=value.val(); this.setState({colorCustomer:(val!=null)?val.color:false, colorCustomerOld:(val!=null)?val.color:false, })  })
        }
        this.getAllCar()
        
        if(this.state.params.driver) this.setState({partnerWrite:true,admin:true}) 
        else get(child(ref(getDatabase(firebase)), '/users/'+getAuth(firebase).currentUser.uid+"/driver")).then(value => {var val=value.val(); if(val!=null && val==true) this.setState({partnerWrite:true,admin:true})  })

        if(this.state.params.findClientById!=undefined){
          get(child(ref(getDatabase(firebase)), '/users/'+this.state.params.findClientById)).then(value => {
            var vale=value.val();

            var phone=vale.phone;
            if(vale.phone!=undefined && (vale.phone[0]=="+" || (vale.phone[0]==0 && vale.phone[1]==0) )){
              var result=this.findPhoneIID(vale.phone)
              if(vale.phone[0]=="+") phone=phone.replace(result.idd,"")
              else {result.idd=result.idd.replace("+","00"); phone=phone.replace(result.idd,"") }


              this.setState({countryPhone:result.id,countryPhoneIID:result.idd, flagPhone:result.flag});
            } 




            this.setState({tvaNumber:(vale.tvaNumber!=undefined)?vale.tvaNumber:"",noVAT:(vale.noVAT!=undefined)?vale.noVAT:"",adsNotification:(vale.adsNotification==false)?false:true,adsNotificationOld:(vale.adsNotification==false)?false:true, usersMoreInfosDriver:(vale.usersMoreInfosDriver!=undefined)?vale.usersMoreInfosDriver:"",accountClientDisabled:(vale.accountClientDisabled==true)?true:false,noLanguage:(vale.noLanguage!=undefined)?vale.noLanguage:{}, noZone:(vale.noZone!=undefined)?vale.noZone:{}, blackList:(vale.blackList!=undefined)?vale.blackList:{}, provider:(vale.provider==true)?true:false,adminNotRace:(vale.adminNotRace==true)?true:false,driverAppli:(vale.driver==true)?true:false, partner:(vale.partner==true)?true:false,manager:(vale.manager!=false && vale.manager!=undefined)?vale.manager:false,managerInfo:(vale.managerInfo!=undefined)?vale.managerInfo:{}, customerPro:(vale.customerPro==true)?true:false,vip:(vale.vip==true)?true:false,favForbidden:(vale.favForbidden==true)?true:false,name:vale.name,adressBill:(vale.adressBill!=undefined)?vale.adressBill:"", cityBill:(vale.cityBill!=undefined)?vale.cityBill:"", enterprise:(vale.enterprise!=undefined)?vale.enterprise:"",lastName:vale.lastName,phone:phone,email:vale.email,initialEmail:vale.email, clientID:this.state.params.findClientById,manualClient:(vale.manualClient!=undefined)?vale.manualClient:false})
            if(vale.favoriteDriver!=undefined) this.setState({partnerSelected:vale.favoriteDriver})
            if(vale.provider==true) this.setState({privilegeProvider:(vale.privilegeProvider!=undefined)?vale.privilegeProvider:"basic", adress:(vale.dispenserMode!=undefined && vale.dispenserMode.adress!=undefined)?vale.dispenserMode.adress:"" })
            if(vale.partner==true){

              this.setState({
              evtc:(vale.evtc!=undefined)?vale.evtc.toString():"",
              ntaxi:(vale.ntaxi!=undefined)?vale.ntaxi.toString():"",
              nloti:(vale.nloti!=undefined)?vale.nloti.toString():"",
              
              oldPartner:true,
              tvaPercentClassic:(vale.tvaPercentClassic!=undefined)?vale.tvaPercentClassic+"%":"",
              tvaPercentDispo:(vale.tvaPercentDispo!=undefined)?vale.tvaPercentDispo+"%":"",
              commission:(vale.commission!=undefined)?vale.commission+"%":"",

              privilegeDriver:(vale.privilegeDriver!=undefined)?vale.privilegeDriver:"basic",
              acceptedOptions:(vale.acceptedOptions!=undefined)?vale.acceptedOptions:{},
              viewPhone:(vale.viewPhone!=undefined)?vale.viewPhone:"never",
              billMode:(vale.billMode!=undefined)?vale.billMode:"appCompany",
              tvaAdmission:(vale.tvaAdmission!=undefined)?vale.tvaAdmission:false,
              partnerCompanyWithCommission:(vale.partnerCompanyWithCommission!=undefined)?vale.partnerCompanyWithCommission:false,
              forceTVAPercent:(vale.forceTVAPercent!=undefined)?vale.forceTVAPercent:false,
              companyBrand:(vale.companyBrand!=undefined)?vale.companyBrand:"",
              companyAdress:(vale.companyAdress!=undefined)?vale.companyAdress:"",
              companyCity:(vale.companyCity!=undefined)?vale.companyCity:"",
              companyEmail:(vale.companyEmail!=undefined)?vale.companyEmail:"",
              companyName:(vale.companyName!=undefined)?vale.companyName:"",
              rcs:(vale.rcs!=undefined)?vale.rcs:"",
              
              assuranceName:(vale.assuranceName!=undefined)?vale.assuranceName:"",
              assuranceNumber:(vale.assuranceNumber!=undefined)?vale.assuranceNumber:"",
              companySiret:(vale.companySiret!=undefined)?vale.companySiret:"",
              })


            }



            if(this.state.globalUser==true && vale.manualClient!=true && (vale.partner==true || vale.driver==true) && this.state.params.reviews!=undefined && this.state.params.reviews.activateDriverNotation==true) this.searchNote(this.state.params.findClientById)
            else if(this.state.globalUser==true && vale.manualClient!=true && (vale.partner!=true && vale.driver!=true) && this.state.params.reviews!=undefined && this.state.params.reviews.activateCustomerNotation==true) this.searchNote(this.state.params.findClientById)



            if(vale.carList!=undefined){
              var i;
              var allCar=this.state.carList;
              if(allCar={}) this.setState({carList:vale.carList})
              else{
                var cla=Object.keys(vale.carList);
                for(i=0;i<cla.length;i++){
                  if(allCar[cla[i]]!=undefined) allCar[cla[i]]=vale.carList[cla[i]]
                }
                this.setState({carList:allCar})
              }
            }

            if(vale.carModel!=undefined) this.setState({carModel:vale.carModel})
            else if(vale.car!=undefined) {
              var cm={0:vale.car}
              this.setState({carModel:cm})

            }

            
          });
          get(child(ref(getDatabase(firebase)), '/usersMoreInfos/'+this.state.params.findClientById)).then(snapshot => { 
              var val=snapshot.val();
              if(val!=null){
                var r={usersMoreInfos:val.data,usersMoreInfoSave:val.data}

                
                
                if(val.permananteReduction!=undefined && val.permananteReduction!="") r.permananteReduction=val.permananteReduction+"%"
                if(val.providerCommission!=undefined && val.providerCommission!="") r.providerCommission=val.providerCommission+"%"
                if(val.deferredPayment!=undefined) r.deferredPayment=val.deferredPayment;
                this.setState(r)
              }

          })
        }
        else{
          
          if(this.state.params.globalUser!==undefined && this.state.params.globalUser==false) this.setState({globalUser:false})


            var phone=this.state.params.clientInfo.phone;
          if(this.state.params.clientInfo.phone!=undefined && (this.state.params.clientInfo.phone[0]=="+" || (this.state.params.clientInfo.phone[0]==0 && this.state.params.clientInfo.phone[1]==0) )){
            var result=this.findPhoneIID(this.state.params.clientInfo.phone)
            if(this.state.params.clientInfo.phone[0]=="+") phone=phone.replace(result.idd,"")
            else {result.idd=result.idd.replace("+","00"); phone=phone.replace(result.idd,"") }


            this.setState({countryPhone:result.id,countryPhoneIID:result.idd, flagPhone:result.flag});
          } 


          this.setState({tvaNumber:(this.state.params.clientInfo.tvaNumber!=undefined)?this.state.params.clientInfo.tvaNumber:"",  noVAT:(this.state.params.clientInfo.noVAT!=undefined)?this.state.params.clientInfo.noVAT:false,   noLanguage:(this.state.params.clientInfo.noLanguage!=undefined)?this.state.params.clientInfo.noLanguage:{},  noZone:(this.state.params.clientInfo.noZone!=undefined)?this.state.params.clientInfo.noZone:{},blackList:(this.state.params.clientInfo.blackList!=undefined)?this.state.params.clientInfo.blackList:[],clientList:(this.state.params.clientList!=undefined)?this.state.params.clientList:[],partnerList:(this.state.params.partnerList!=undefined)?this.state.params.partnerList:[],accountClientDisabled:(this.state.params.clientInfo.accountClientDisabled==true)?true:false,provider:(this.state.params.clientInfo.provider==true)?true:false,adminNotRace:(this.state.params.clientInfo.adminNotRace==true)?true:false, driverAppli:(this.state.params.clientInfo.driver==true)?true:false, partner:(this.state.params.clientInfo.partner==true)?true:false, manager:(this.state.params.clientInfo.manager!=false && this.state.params.clientInfo.manager!=undefined)?this.state.params.clientInfo.manager:false,managerInfo:(this.state.params.clientInfo.managerInfo!=undefined)?this.state.params.clientInfo.managerInfo:{}, customerPro:(this.state.params.clientInfo.customerPro==true)?true:false, vip:(this.state.params.clientInfo.vip==true)?true:false,favForbidden:(this.state.params.clientInfo.favForbidden==true)?true:false, usersMoreInfosDriver:(this.state.params.clientInfo.usersMoreInfosDriver!=undefined)?this.state.params.clientInfo.usersMoreInfosDriver:"",  name:this.state.params.clientInfo.name,lastName:this.state.params.clientInfo.lastName, adressBill:(this.state.params.clientInfo.adressBill!=undefined)?this.state.params.clientInfo.adressBill:"",cityBill:(this.state.params.clientInfo.cityBill!=undefined)?this.state.params.clientInfo.cityBill:"", enterprise:(this.state.params.clientInfo.enterprise!=undefined)?this.state.params.clientInfo.enterprise:"" , enterprise:(this.state.params.clientInfo.enterprise!=undefined)?this.state.params.clientInfo.enterprise:"",phone:phone,email:this.state.params.clientInfo.email,initialEmail:this.state.params.clientInfo.email, clientID:this.state.params.clientInfo.clientID,manualClient:(this.state.params.clientInfo.manualClient!=undefined)?this.state.params.clientInfo.manualClient:false})
          if(this.state.params.clientInfo.favoriteDriver!=undefined) this.setState({partnerSelected:this.state.params.clientInfo.favoriteDriver})
          
          if(this.state.params.globalUser!==undefined && this.state.params.globalUser!=false) get(child(ref(getDatabase(firebase)), '/usersMoreInfos/'+this.state.params.clientInfo.clientID)).then(snapshot => { 
              var val=snapshot.val();
              if(val!=null) {
                
                var r={usersMoreInfos:val.data,usersMoreInfoSave:val.data,}
                
                if(val.permananteReduction!=undefined && val.permananteReduction!="") r.permananteReduction=val.permananteReduction+"%"
                if(val.providerCommission!=undefined && val.providerCommission!="") r.providerCommission=val.providerCommission+"%"
                if(val.deferredPayment!=undefined) r.deferredPayment=val.deferredPayment;
                this.setState(r)
              }
          })
            if(this.state.params.clientInfo.provider==true) this.setState({privilegeProvider:(this.state.params.clientInfo.privilegeProvider!=undefined)?this.state.params.clientInfo.privilegeProvider:"basic",adress:(this.state.params.clientInfo.dispenserMode!=undefined && this.state.params.clientInfo.dispenserMode.adress!=undefined)?this.state.params.clientInfo.dispenserMode.adress:""})

          if(this.state.params.clientInfo.partner==true){

            this.setState({
                oldPartner:true,
                viewPhone:(this.state.params.clientInfo.viewPhone!=undefined)?this.state.params.clientInfo.viewPhone:"never",
                privilegeDriver:(this.state.params.clientInfo.privilegeDriver!=undefined)?this.state.params.clientInfo.privilegeDriver:"basic",
                acceptedOptions:(this.state.params.clientInfo.acceptedOptions!=undefined)?this.state.params.clientInfo.acceptedOptions:{},
                evtc:(this.state.params.clientInfo.evtc!=undefined)?this.state.params.clientInfo.evtc.toString():"",
                ntaxi:(this.state.params.clientInfo.ntaxi!=undefined)?this.state.params.clientInfo.ntaxi.toString():"",
                nloti:(this.state.params.clientInfo.nloti!=undefined)?this.state.params.clientInfo.nloti.toString():"",
                billMode:(this.state.params.clientInfo.billMode!=undefined)?this.state.params.clientInfo.billMode:"appCompany",
                adsNotification:(this.state.params.clientInfo.adsNotification!=undefined)?this.state.params.clientInfo.adsNotification:true,
                adsNotificationOld:(this.state.params.clientInfo.adsNotification!=undefined)?this.state.params.clientInfo.adsNotification:true,
                tvaAdmission:(this.state.params.clientInfo.tvaAdmission!=undefined)?this.state.params.clientInfo.tvaAdmission:false,
                partnerCompanyWithCommission:(this.state.params.clientInfo.partnerCompanyWithCommission!=undefined)?this.state.params.clientInfo.partnerCompanyWithCommission:false,
                forceTVAPercent:(this.state.params.clientInfo.forceTVAPercent!=undefined)?this.state.params.clientInfo.forceTVAPercent:false,
                companyBrand:(this.state.params.clientInfo.companyBrand!=undefined)?this.state.params.clientInfo.companyBrand:"",
                companyAdress:(this.state.params.clientInfo.companyAdress!=undefined)?this.state.params.clientInfo.companyAdress:"",
                companyCity:(this.state.params.clientInfo.companyCity!=undefined)?this.state.params.clientInfo.companyCity:"",
                companyEmail:(this.state.params.clientInfo.companyEmail!=undefined)?this.state.params.clientInfo.companyEmail:"",
                companyName:(this.state.params.clientInfo.companyName!=undefined)?this.state.params.clientInfo.companyName:"",
                rcs:(this.state.params.clientInfo.rcs!=undefined)?this.state.params.clientInfo.rcs:"",
                assuranceName:(this.state.params.clientInfo.assuranceName!=undefined)?this.state.params.clientInfo.assuranceName:"",
                assuranceNumber:(this.state.params.clientInfo.assuranceNumber!=undefined)?this.state.params.clientInfo.assuranceNumber:"",
                companySiret:(this.state.params.clientInfo.companySiret!=undefined)?this.state.params.clientInfo.companySiret:"",
                commission:(this.state.params.clientInfo.commission!=undefined)?this.state.params.clientInfo.commission+"%":"",
                
                tvaPercentClassic:(this.state.params.clientInfo.tvaPercentClassic!=undefined)?this.state.params.clientInfo.tvaPercentClassic+"%":"",
                tvaPercentDispo:(this.state.params.clientInfo.tvaPercentDispo!=undefined)?this.state.params.clientInfo.tvaPercentDispo+"%":"",
                })
          }


          if(this.state.params.globalUser==true && this.state.params.clientInfo.manualClient!=true && (this.state.params.clientInfo.partner==true || this.state.params.clientInfo.driver==true) && this.state.params.reviews!=undefined && this.state.params.reviews.activateDriverNotation==true) this.searchNote(this.state.params.clientInfo.clientID)
            else if(this.state.params.globalUser==true && this.state.params.clientInfo.manualClient!=true && (this.state.params.clientInfo.partner!=true && this.state.params.clientInfo.driver!=true) && this.state.params.reviews!=undefined && this.state.params.reviews.activateCustomerNotation==true) this.searchNote(this.state.params.clientInfo.clientID)




          if(this.state.params.clientInfo.carList!=undefined){
              var i;
              var allCar=this.state.carList;
              if(allCar={}) this.setState({carList:this.state.params.clientInfo.carList})
              else{
                var cla=Object.keys(this.state.params.clientInfo.carList);
                for(i=0;i<cla.length;i++){
                  if(allCar[cla[i]]!=undefined) allCar[cla[i]]=this.state.params.clientInfo.carList[cla[i]]
                }
                this.setState({carList:allCar})
              }
              
          }
          if(this.state.params.clientInfo.carModel!=undefined) this.setState({carModel:this.state.params.clientInfo.carModel})
          else if(this.state.params.clientInfo.car!=undefined) {
            var cm={0:this.state.params.clientInfo.car}
            this.setState({carModel:cm})

          }


        }
        
      }
      else if(this.state.newClient==false && this.state.createAccount==false){
        get(child(ref(getDatabase(firebase)), '/users/' + getAuth(firebase).currentUser.uid)).then(value => {
          var val = value.val();
          
          var phone=val.phone;
          if(val.phone!=undefined && (val.phone[0]=="+" || (val.phone[0]==0 && val.phone[1]==0) )){
            var result=this.findPhoneIID(val.phone)
            if(val.phone[0]=="+") phone=phone.replace(result.idd,"")
            else {result.idd=result.idd.replace("+","00"); phone=phone.replace(result.idd,"") }


            this.setState({countryPhone:result.id,countryPhoneIID:result.idd, flagPhone:result.flag});
          } 

          this.setState({name: val.name,lastName: val.lastName,adsNotification:(val.adsNotification==false)?false:true,adsNotificationOld:(val.adsNotification==false)?false:true, usersMoreInfosDriver:(val.usersMoreInfosDriver!=undefined)?val.usersMoreInfosDriver:"", phone: phone,email: val.email,initialEmail:val.email, adressBill:(val.adressBill!=undefined)?val.adressBill:"" , cityBill:(val.cityBill!=undefined)?val.cityBill:"",  enterprise:(val.enterprise!=undefined)?val.enterprise:""});
          if(val.favoriteDriver!=undefined) this.setState({partnerSelected:val.favoriteDriver})
          if(val.partner==true) this.setState({partner:true,oldPartner:true})
          if(val.provider==true){ this.setState({providerMyAccount:true})
            if(val.dispenserMode!=undefined && val.dispenserMode.adress!=undefined) this.setState({adress:val.dispenserMode.adress})
          }
        });

      }
      if(this.state.createAccount!=true && this.state.newClient!=true && this.state.adminView!=true && info.appliVersion) {


         fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/mavVersion/"+info.bundleIdentifer, {
          headers: {"Content-Type": "application/json"},method: "POST"}).then((response) => response.json()).then((responseJson) => {
          var res=responseJson
            if(res.appVersion!=undefined) this.setState({appliLastVersion:res.appVersion})
          }) 

      }

      if(this.state.newClient==true && this.state.params.prefill!=undefined){
        if(this.state.params.prefill.name!=undefined) this.setState({name:this.state.params.prefill.name})
        if(this.state.params.prefill.lastName!=undefined) this.setState({lastName:this.state.params.prefill.lastName})
        if(this.state.params.prefill.phone!=undefined) this.setState({phone:this.state.params.prefill.phone})
        if(this.state.params.prefill.email!=undefined) this.setState({email:this.state.params.prefill.email})
      }

      if(info.disableFavoriteDriverForCustomer==false || (this.state.adminView==true && info.disableFavoriteDriverForAdmin==false)) this.getPartnersList()
      
  }
  

  getPartnersList(){
    fetch("https://us-central1-"+info.firebaseProjectID+".cloudfunctions.net/getPartner", {body: "{\"uuid\":\"new\"}",method: "POST"}).then((response) => response.json()).then((responseJson) => {
          var res=responseJson
          var res2=[{id:-1,text:strings.noFavoriteDriver}]
          var i; 
          for(i=0;i<res.length;i++) res2.push(res[i])
          this.setState({partnerListAccount:res2})
          
        }).catch((err) => { console.log("error getPartnersList"); console.log(err); timer.setTimeout("getPartnersList", () => { this.getPartnersList();  }, 2000);   })
    }






  updateAccount(){ 
    console.log(this.state.clientID)
    var td=false;


    if(this.state.clientID!=undefined && this.state.clientID!=""){
      var fireInfo={} 

      if(this.state.adminView==true && this.state.defineColorForCustomer==true && (this.state.colorCustomerOld!=this.state.colorCustomer)){
          fireInfo['/usersColor/'+this.state.clientID+"/color"]=this.state.colorCustomer
      } 

      var perRed=this.state.permananteReduction;
      if(perRed!="") perRed=parseFloat(perRed);
      if(perRed==NaN || perRed=="NaN" || perRed>100){
        td=true;
        this.alert.onAlert({title:strings.invalidPermanenteReduction})
      }
      else{
        var comProvErr=false;
        if(this.state.provider==true){
          var providerCom=this.state.providerCommission;
          if(providerCom!="") providerCom=parseFloat(providerCom);
          if(providerCom==NaN || providerCom=="NaN" || providerCom>100){
            td=true;
            comProvErr=true;
            this.alert.onAlert({title:strings.invalidProviderCommission})
          }
        } 
        if(comProvErr==false){
            var usersMoreInfosFire={permananteReduction:perRed,data:this.state.usersMoreInfos,deferredPayment:this.state.deferredPayment, usersMoreInfosDriver:this.state.usersMoreInfosDriver}
            if(this.state.provider===true) usersMoreInfosFire.providerCommission=providerCom;
            if(this.state.globalUser ==true) {
              const fireInfo={} 
              fireInfo['/usersMoreInfos/'+this.state.clientID]=usersMoreInfosFire
              update(ref(getDatabase(firebase)), fireInfo)

            }
          }
        }






      



      if((this.state.name!="" || this.state.lastName!="") && (this.state.partnerWrite==true || this.state.globalUser==false ) ) {
        var phone=this.state.countryPhoneIID+this.state.phone;
        var linkUser=(this.state.globalUser==true)?"users/":"usersListClients/"+getAuth(firebase).currentUser.uid+"/";

        fireInfo[linkUser + this.state.clientID+"/partner"]=(this.state.partner==true)?true:null
        fireInfo[linkUser + this.state.clientID+"/manager"]=(this.state.manager==true)?true:null
        fireInfo[linkUser + this.state.clientID+"/customerPro"]=(this.state.customerPro==true)?true:null
        fireInfo[linkUser + this.state.clientID+"/vip"]=(this.state.vip==true)?true:null
        fireInfo[linkUser + this.state.clientID+"/provider"]=(this.state.provider==true)?true:null
        fireInfo[linkUser + this.state.clientID+"/name"]=this.state.name
        fireInfo[linkUser + this.state.clientID+"/lastName"]=this.state.lastName
        fireInfo[linkUser + this.state.clientID+"/enterprise"]=(this.state.enterprise!="" && this.state.enterprise!=undefined)?this.state.enterprise:null
        fireInfo[linkUser + this.state.clientID+"/email"]=(this.state.email!="" && this.state.email!=undefined)?this.state.email:null
        fireInfo[linkUser + this.state.clientID+"/phone"]=(this.state.phone!="" && this.state.phone!=undefined)?this.state.phone:null
        fireInfo[linkUser + this.state.clientID+"/blackList"]=this.state.blackList
        fireInfo[linkUser + this.state.clientID+"/noZone"]=this.state.noZone
        fireInfo[linkUser + this.state.clientID+"/noLanguage"]=this.state.noLanguage
        fireInfo[linkUser + this.state.clientID+"/usersMoreInfosDriver"]=(this.state.usersMoreInfosDriver!="")?this.state.usersMoreInfosDriver:null
        fireInfo[linkUser + this.state.clientID+"/adsNotification"]=(this.state.adsNotification==true)?null:false
        fireInfo[linkUser + this.state.clientID+"/managerInfo"]=(this.state.managerInfo=={})?null:this.state.managerInfo;
        fireInfo[linkUser + this.state.clientID+"/adressBill"]=(this.state.adressBill!="")?this.state.adressBill:null;
        fireInfo[linkUser + this.state.clientID+"/cityBill"]=(this.state.cityBill!="")?this.state.cityBill:null;
        fireInfo[linkUser + this.state.clientID+"/favForbidden"]=(this.state.favForbidden==true)?true:null;
        fireInfo[linkUser + this.state.clientID+"/adsNotification"]=(this.state.adsNotification==false)?false:null;
        fireInfo[linkUser + this.state.clientID+"/tvaNumber"]=(this.state.tvaNumber!=undefined && this.state.tvaNumber!="")?this.state.tvaNumber:null;
        fireInfo[linkUser + this.state.clientID+"/noVAT"]=(this.state.noVAT==true)?true:null; 
        

        if(this.state.driverAppli==true) fireInfo[linkUser + this.state.clientID+"/adminNotRace"]=(this.state.partner==false)?this.state.adminNotRace:false;
        
        if(this.state.provider===true) {
              fireInfo[linkUser + this.state.clientID+"/privilegeProvider"]=this.state.privilegeProvider;
              if(this.state.adress!=undefined && this.state.adress!="") {
                fireInfo[linkUser + this.state.clientID+"/dispenserMode/adress"]=this.state.adress
              } 
        }

        if(info.disableFavoriteDriverForCustomer==false || (this.state.adminView==true && info.disableFavoriteDriverForAdmin==false) ) fireInfo[linkUser + this.state.clientID+"/favoriteDriver"]=this.state.partnerSelected;
        

        
        
        
        if(this.state.partner==true){
          if((this.state.billMode==="double" || this.state.billMode==="partnerCompany" ) && (parseFloat(this.state.commission)<0 || parseFloat(this.state.commission)>100 || (parseFloat(this.state.commission)).toString()=="NaN")){td=true; this.alert.onAlert({title:strings.thankValidCommission})}
          else if(this.state.forceTVAPercent===true && (parseFloat(this.state.tvaPercentClassic)<1 || parseFloat(this.state.tvaPercentClassic)>100 || (parseFloat(this.state.tvaPercentClassic)).toString()=="NaN")) {td=true; this.alert.onAlert({title:strings.thankValidCommission})}
          else if(this.state.forceTVAPercent===true && (parseFloat(this.state.tvaPercentDispo)<1 || parseFloat(this.state.tvaPercentDispo)>100 || (parseFloat(this.state.tvaPercentDispo)).toString()=="NaN")) {td=true; this.alert.onAlert({title:strings.thankValidCommission})}
          else if((this.state.billMode==="double" || this.state.billMode==="partnerCompany" ) && (this.state.companyBrand=="" ||  this.state.companyAdress=="" ||  this.state.companyCity=="" || this.state.companyEmail=="" || this.state.companyName=="" || this.state.rcs=="" || this.state.assuranceName=="" || this.state.assuranceNumber=="" || this.state.companySiret=="")  ) {td=true; this.alert.onAlert({title:strings.thanksAllItems})}
            else{
                fireInfo[linkUser + this.state.clientID+"/carList"]=this.state.carList;
                fireInfo[linkUser + this.state.clientID+"/billMode"]=this.state.billMode;
                fireInfo[linkUser + this.state.clientID+"/carModel"]=this.state.carModel;
                fireInfo[linkUser + this.state.clientID+"/evtc"]=this.state.evtc.toString();
                fireInfo[linkUser + this.state.clientID+"/ntaxi"]=this.state.ntaxi.toString();
                fireInfo[linkUser + this.state.clientID+"/nloti"]=this.state.nloti.toString();
                fireInfo[linkUser + this.state.clientID+"/viewPhone"]=this.state.viewPhone;
                fireInfo[linkUser + this.state.clientID+"/privilegeDriver"]=this.state.privilegeDriver;
                fireInfo[linkUser + this.state.clientID+"/acceptedOptions"]=this.state.acceptedOptions;

                if(this.state.partnerCompanyWithCommission==true) fireInfo[linkUser + this.state.clientID+"/partnerCompanyWithCommission"]=true;
                else fireInfo[linkUser + this.state.clientID+"/partnerCompanyWithCommission"]=null;
                 
                if(this.state.billMode!="appCompany"){

                      fireInfo[linkUser + this.state.clientID+"/tvaAdmission"]=this.state.tvaAdmission
                      fireInfo[linkUser + this.state.clientID+"/forceTVAPercent"]=this.state.forceTVAPercent
                      fireInfo[linkUser + this.state.clientID+"/companyBrand"]=this.state.companyBrand
                      fireInfo[linkUser + this.state.clientID+"/companyAdress"]=this.state.companyAdress
                      fireInfo[linkUser + this.state.clientID+"/companyCity"]=this.state.companyCity
                      fireInfo[linkUser + this.state.clientID+"/companyEmail"]=this.state.companyEmail
                      fireInfo[linkUser + this.state.clientID+"/companyName"]=this.state.companyName
                      fireInfo[linkUser + this.state.clientID+"/rcs"]=this.state.rcs
                      fireInfo[linkUser + this.state.clientID+"/assuranceName"]=this.state.assuranceName
                      fireInfo[linkUser + this.state.clientID+"/assuranceNumber"]=this.state.assuranceNumber
                      fireInfo[linkUser + this.state.clientID+"/companySiret"]=this.state.companySiret
                      fireInfo[linkUser + this.state.clientID+"/commission"]=parseFloat(this.state.commission)
               

                }

                if(this.state.forceTVAPercent===true){
                  fireInfo[linkUser + this.state.clientID+"/tvaPercentClassic"]=parseFloat(this.state.tvaPercentClassic)
                  fireInfo[linkUser + this.state.clientID+"/tvaPercentDispo"]=parseFloat(this.state.tvaPercentDispo)
                }
                
          }
        }else if(this.state.oldPartner==true) {
            fireInfo[linkUser + this.state.clientID+"/lastDriverPositionLatitude"]=null
        }

        




        
      }

      if(td===false){
        update(ref(getDatabase(firebase)), fireInfo)
        if(this.state.params.updateData!=undefined) this.state.params.updateData()

        if(this.props.params!=undefined) this.props.params.goBack()
        else this.props.navigation.goBack();

      } 


    }
    else{
        var user = getAuth(firebase).currentUser;
        var fireInfo={} 
        if (this.state.name.length > 0 && this.state.lastName.length > 0) {
            let reg = /[a-z0-9._-]+@[a-z0-9._-]{2,}\.[a-z]{2,8}$/;
            if(this.state.phone=="") this.alert.onAlert({title:strings.incorrectPhoneNumber}) 
            else if (reg.test(this.state.email) === true) {

              if(this.state.emailHasChanged==true){
                   user.updateEmail(this.state.email).catch(function(error) {
                    this.alert.onAlert({title:strings.errorDuringUpdateEmail})

                  });
              }

                var phone=this.state.countryPhoneIID+this.state.phone;

                fireInfo["users/" + user.uid +"/name"]=this.state.name
                fireInfo["users/" + user.uid +"/lastName"]=this.state.lastName
                fireInfo["users/" + user.uid +"/enterprise"]=(this.state.enterprise!="" && this.state.enterprise!=undefined)?this.state.enterprise:null
                fireInfo["users/" + user.uid +"/email"]=(this.state.email!="" && this.state.email!=undefined)?this.state.email:null
                fireInfo["users/" + user.uid +"/phone"]=phone
                fireInfo["users/" + user.uid +"/usersMoreInfosDriver"]=(this.state.usersMoreInfosDriver!="")?this.state.usersMoreInfosDriver:null
                fireInfo["users/" + user.uid +"/adressBill"]=(this.state.adressBill!="")?this.state.adressBill:null;
                fireInfo["users/" + user.uid +"/adsNotification"]=(this.state.adsNotification==true)?null:false
                

                if(info.disableFavoriteDriverForCustomer==false || (this.state.adminView==true && info.disableFavoriteDriverForAdmin==false) ) fireInfo["users/" + user.uid +"/favoriteDriver"]=this.state.partnerSelected;
                if(this.state.providerMyAccount==true && this.state.adress!=undefined && this.state.adress!="") {
                  fireInfo["users/" + user.uid+"/dispenserMode/adress"]=this.state.adress
                }
                
                update(ref(getDatabase(firebase)), fireInfo)

                if(this.state.params.update!=undefined) this.state.params.update()



                if(this.state.adsNotification!=this.state.adsNotificationOld) {
                    this.alert.onAlert({title:strings.modifyOk, subTitle:strings.modificationOkDevice,buttons:[{text: strings.ok,onPress: (value) => {
                      if(this.props.params!=undefined) this.props.params.goBack()
                      else this.props.navigation.goBack(); }}]
                    });
                }
                else {
                  if(this.props.params!=undefined) this.props.params.goBack()
                  else this.props.navigation.goBack();
                }
                
                


              
            } else this.alert.onAlert({title:strings.incorrectEmailFormat});
          } else this.alert.onAlert({title:strings.incorrectNameLastName});
    }
    
  }

  createManualClient(){
    if(this.state.name=="") this.alert.onAlert({title:strings.clientNameError})
    else{
     this.state.params.update(this.state)
     if(this.props.params!=undefined) this.props.params.goBack()
      else this.props.navigation.goBack();
                
      
    }
  }

  createAccount(){
    if(this.state.waiting==false){
      this.setState({waiting:true})

      if(this.state.name.length>0 && this.state.lastName.length>0){
        let reg = /[a-z0-9._-]+@[a-z0-9._-]{2,}\.[a-z]{2,8}$/;
        if(reg.test(this.state.email)===true){
          if(this.state.phone==""){this.setState({waiting:false});this.alert.onAlert({title:strings.incorrectPhoneNumber}) }
          else {
            if(this.state.password.length<8){this.setState({waiting:false});this.alert.onAlert({title:strings.incorrectPasswordLength})}
            else {
              let reg = /[0-9]/;
              if(!reg.test(this.state.password)) {this.setState({waiting:false});this.alert.onAlert({title:strings.incorrectPasswordNumber}) }
              else {
                let reg1 = /[a-z]/;let reg2 = /[A-Z]/;
                if(!(reg1.test(this.state.password) && reg2.test(this.state.password))) {this.setState({waiting:false}); this.alert.onAlert({title:strings.incorrectPasswordUpperCase}) }
                else { 
                  if(this.state.cguAgree==false){this.setState({waiting:false});this.alert.onAlert({title:strings.cguMustAgree}) }
                  else{
                    createUserWithEmailAndPassword(getAuth(firebase),this.state.email, this.state.password).then(snapshot => {
                      this.setState({waiting:false})
                      this.unsubscribe = onAuthStateChanged(getAuth(firebase), user => {
                        if(user!=null){
                          var phoneTotal=this.state.countryPhoneIID+this.state.phone
                          var sendFi={name: this.state.name,lastName:this.state.lastName,email:this.state.email,phone:phoneTotal, enterprise:this.state.enterprise, usersMoreInfosDriver:(this.state.usersMoreInfosDriver!="")?this.state.usersMoreInfosDriver:null}
                          if(info.disableFavoriteDriverForCustomer==false && this.state.partnerSelected.id!=-1) sendFi.favoriteDriver=this.state.partnerSelected;
                          
                          const fireInfo={} 
                          fireInfo['users/' + user.uid]=sendFi
                          update(ref(getDatabase(firebase)), fireInfo)

                        }
                        this.unsubscribe();
                      });
                    }).catch(error => {
                        this.setState({waiting:false})
                        if(error.code==="auth/email-already-in-use") this.alert.onAlert({title:strings.mailAlreadyUse}) 
                        else this.alert.onAlert({title:strings.errorDefault}) 
                      })}
                  }
                }
              }
            }
          }
          else {this.setState({waiting:false}); this.alert.onAlert({title:strings.incorrectEmailFormat}) }
        }
        else {this.setState({waiting:false});this.alert.onAlert({title:strings.incorrectNameLastName}) }
      }
  }
  onFavoritePlace= data => {
    this.setState({adress:data})
  }




  takePicture(){

  
    
    var options = {title: strings.selectPicture,chooseFromLibraryButtonTitle:strings.library, takePhotoButtonTitle:strings.camera,cancelButtonTitle:strings.cancel,storageOptions: {skipBackup: true,path: 'images',quality:0.5}};


    launchImageLibrary(options, (response) => {
      

      if (response.didCancel) {console.log('User cancelled image picker');}else if (response.error) {console.log('ImagePicker Error: ', response.error);}else if (response.customButton) {console.log('User tapped custom button: ', response.customButton);}
      else {

        const image = Platform.OS === 'ios' ? response.assets[0].uri.replace('file://', '') : response.assets[0].uri
 
        const Blob = RNFetchBlob.polyfill.Blob
        const fs = RNFetchBlob.fs
        window.XMLHttpRequest = RNFetchBlob.polyfill.XMLHttpRequest
        window.Blob = Blob
        const Fetch = RNFetchBlob.polyfill.Fetch
        window.fetch = new Fetch({auto : true,binaryContentTypes : ['image/','video/','audio/','foo/',]}).build()
        
 
        this.setState({waitingPicture:true})

        let uploadBlob = null

        const imageRef = refStorage(getStorage(), 'partners/'+getAuth(firebase).currentUser.uid+'/picture.jpg');
        let mime = 'image/jpg'
        fs.readFile(image, 'base64')
        .then((data) => {
          console.log("1er then")
          console.log(data)
          return Blob.build(data, { type: `${mime};BASE64` })
        })
        .then((blob) => {
          console.log("2eme then")
          uploadBlob = blob

          return uploadBytes(imageRef, blob)
          })
        .then(() => {
          console.log("3eme then")
          
          uploadBlob.close()
          this.alert.onAlert({title:strings.photoOK})
           this.setState({waitingPicture:false})
          return getDownloadURL(imageRef)
        }).then(url => {
              console.log("4eme then "+url)
        })
        .catch((error) => {
          
          this.setState({waitingPicture:false})
          console.log(error);

          if(error.indexOf("EACCES (Permission denied)") ) this.alert.onAlert({title:"Le téléphone n'autorise pas l'envoi de la photo"});
          
 
        })  

    }
    });

    
     
  }

  changeNoteReview= (type,value) => {
    var note=this.state.note;
    if(type=="note") note.note=value;
    else note.reviews=value; 

    const fireInfo={} 
    fireInfo['reviews/users/' + this.state.clientID]={infos:note}
    update(ref(getDatabase(firebase)), fireInfo)

    this.setState({note:note})

  }


viewClientCredit(){
  if(this.state.waitCreditCustomer!=true){
      this.setState({waitCreditCustomer:true})
      get(child(ref(getDatabase(firebase)), 'settings/extraEUMode/')).then(value => {
          var val=value.val()
          this.getCreditUser((val==true)?true:false)
      })
    }
  }

  getCreditUser(extraEUMode){
    console.log("getCreditUser")
     getAuth(firebase).currentUser.getIdToken().then(token => {
              var body={userID:this.state.clientID,adminID:getAuth(firebase).currentUser.uid, bundleIdentifer:info.bundleIdentifer,token:token,bundleAdress:info.firebaseProjectID,version:info.appliVersion
              }
              fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/getUserBalance", {
                      body: JSON.stringify(body),
                        method: "POST"}).then((response) => response.json())
                  .then((responseJson) => {
                            
                            var res=responseJson
                            var tot=[];
                            var eur=this.findMoney();
                            tot.push({amount: res.balance, symbole:eur.symbole, flag:eur.flag,position:eur.position, name:eur[strings.idLangue], moneyID:eur.id  })
                            if(extraEUMode==true){
                              var i;

                              for(i=0;i<moneyList.length;i++){
                                  if(moneyList[i].id!="eu") tot.push({moneyID:moneyList[i].id, name:moneyList[i][strings.idLangue], amount: (res.accountBalanceOther!=undefined && res.accountBalanceOther[moneyList[i].id]!=undefined)?res.accountBalanceOther[moneyList[i].id]:0, symbole:moneyList[i].symbole, flag:moneyList[i].flag,position:moneyList[i].position  })

                              }

                              
                              
                              
                              
                              
                            }

                            this.setState({creditCustomer:tot, waitCreditCustomer:false})
                            
                          
                        }).catch((err) => { console.log("error getCreditUser"); console.log(err); timer.setTimeout("getCreditUser", () => { this.getCreditUser(extraEUMode);  }, 2000);   })

        })
  }

changeCreditSet(body,i,estg){
fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/setUserBalance", {body: JSON.stringify(body),method: "POST"}).then((response) => response.json()).then((responseJson) => {

                console.log(responseJson)
                if(responseJson.error==false){
                  var creditCustomer=this.state.creditCustomer;
                  creditCustomer[i].amount=estg; 
                  this.setState({creditCustomer:creditCustomer})
                }
                else this.alert.onAlert({title:strings.errorDefault});
              }).catch((err) => { console.log("error changeCreditSet"); console.log(err); timer.setTimeout("changeCreditSet", () => { this.changeCreditSet(body,i,estg);  }, 2000);   })

}


  changeCredit(rowData,i){


    this.alert.onAlert({title:strings.modifyCreditCustomer,textInput:{placeholder:((rowData.position=="left")?(rowData.symbole+" "):"")+"40"+((rowData.position=="right")?(rowData.symbole):""),text:((rowData.position=="left")?(rowData.symbole+" "):"")+rowData.amount+((rowData.position=="right")?(rowData.symbole):""),sizeMultiplicator:2,detectSequencePosition:rowData.position,detectSequence:rowData.symbole,keyboardType:"numeric"},buttons:[
      {text: strings.validate,onPress: (value) => {
         var estg=value.toString().replace(rowData.symbole,'')
        estg=parseFloat(estg);

        if(!isNaN(estg) ){
          console.log(estg)

          getAuth(firebase).currentUser.getIdToken().then(token => {
              var body={moneyID:rowData.moneyID,amount:estg, userID:this.state.clientID,adminID:getAuth(firebase).currentUser.uid, bundleIdentifer:info.bundleIdentifer,token:token,bundleAdress:info.firebaseProjectID,version:info.appliVersion}
              
              this.changeCreditSet(body,i, estg);

              

            })





        } else this.alert.onAlert({title:strings.errorDefault});

        

      }},
      {text: strings.cancel, style:"cancel",onPress: () => {}}
      ],})



    
  }

  generateStripeConnect(){
      this.setState({waitGenerateStripeConnect:true});

      getAuth(firebase).currentUser.getIdToken().then(token => {
        console.log("https://us-central1-"+info.firebaseProjectID+".cloudfunctions.net/stripeConnect/create/"+getAuth(firebase).currentUser.uid+"/"+token+"/"+this.state.clientID)
          fetch("https://us-central1-"+info.firebaseProjectID+".cloudfunctions.net/stripeConnect/create/"+getAuth(firebase).currentUser.uid+"/"+token+"/"+this.state.clientID, {method: "GET"}).then((response) => response.json()).then((responseJson) => {
                            
                            var res=responseJson
                            console.log(res)
                            if(res.url!=undefined){
                              Clipboard.setString(res.url);
                              this.alert.onAlert({title:strings.copiedClipboard,subTitle:strings.createLinkSripeConnectLink});
                              
                            }else if(res.errorInfo!=undefined && res.errorInfo.message!=undefined) this.alert.onAlert({title:strings.errorDefault ,subTitle:res.errorInfo.message});
                            else this.alert.onAlert({title:strings.errorDefault});

                            this.setState({waitGenerateStripeConnect:false});

                          })
                })
  }
  


  findMoney(value){
    if(value==undefined) value="eu";
    var final="";
    var i; 
    for(i=0;i<moneyList.length;i++){
      if(final==""){
        if(moneyList[i].id==value) final=moneyList[i];
      }
    }
    return final
  }


  viewPartner(){

      var selected=-1;
      var i;
      for(i=0;i<this.state.partnerListAccount.length;i++){
          if(this.state.partnerListAccount[i].id==this.state.partnerSelected.id) selected=i;
      }
      this.alert.onAlert({title:strings.desiredDriver, items:this.state.partnerListAccount ,itemSelected:selected, buttons:[{text: strings.validate,onPress: (id,value) => {
        this.setState({partnerSelected:this.state.partnerListAccount[id]})
       
      }},{text: strings.cancel, style:"cancel",onPress: () => {}}] })  

  }

  viewBlackListPicker(){

      var i;
      var list=(this.state.partner==true)?this.state.clientList:this.state.partnerList;
      
      this.alert.onAlert({title:strings.blacklistedQuestion, items:list ,itemSelected:-1, buttons:[{text: strings.validate,onPress: (id,value) => {
          var blak=this.state.blackList;
          var alreadyExist=false;
          for(i=0; i<blak.length;i++){
            if(blak[i]==list[id]) alreadyExist=true;
          }
          if(alreadyExist==false) blak.push(list[id]);
          this.setState({blackList:blak})
       
      }},{text: strings.cancel, style:"cancel",onPress: () => {}}] })  

  }


  updatePassRemoveAccount=() => {
    if(this.state.viewMode=="removeAccount"){
              this.alert.onAlert({title:strings.remove,subTitle:strings.removeAnswer,buttons:
                [{text: strings.yes,onPress: () => {
                  this.setState({waiting:true})
                  var user = getAuth(firebase).currentUser;
                  const credential = EmailAuthProvider.credential(getAuth(firebase).currentUser.email,this.state.old);

                reauthenticateWithCredential(getAuth(firebase).currentUser, credential).then(() => {
                  reauthenticateWithCredential(getAuth(firebase).currentUser, credential).then(() => {
                        var user = getAuth(firebase).currentUser;

                        const fireInfo={} 
                        fireInfo['users/' + user.uid]=null
                        fireInfo['usersMoreInfos/' + user.uid]=null
                        update(ref(getDatabase(firebase)), fireInfo)

                        deleteUser(getAuth(firebase).currentUser).then(() => {
                          this.alert.onAlert({title:strings.accountDeleted}); 
                          this.setState({waiting:false})
                          if(this.props.navigation!=undefined) this.props.navigation.goBack()
                          else this.state.params.goBack();


                         }).catch((error) => {this.alert.onAlert({title:strings.errorDefault}); this.setState({waiting:false}) });
                        
                        }).catch((error) => {
                        this.setState({waiting:false})
                        console.log(error)
                        this.alert.onAlert({title:strings.errorDefault}); 
                        this.setState({waiting:false})
                    });
                        
                    }).catch((error) => {
                        this.setState({waiting:false})
                        console.log(error)
                        this.alert.onAlert({title:strings.incorrectOldPassword}); 
                        this.setState({waiting:false})
                    });
                },
              },
              {text: strings.no,style: 'cancel',onPress: () => {}    },]
              }); 
      }
      else {

        if(this.state.new.length<8){this.setState({waiting:false}); this.alert.onAlert({title:strings.incorrectPasswordLength}); }
        else {
          let reg = /[0-9]/;
          if(!reg.test(this.state.new)) {this.setState({waiting:false}); this.alert.onAlert({title:strings.incorrectPasswordNumber}); }
          else {
              let reg1 = /[a-z]/;let reg2 = /[A-Z]/;
              if(!(reg1.test(this.state.new) && reg2.test(this.state.new))) {this.setState({waiting:false}); this.alert.onAlert({title:strings.incorrectPasswordUpperCase}); }
              else { 
                 const credential = EmailAuthProvider.credential(getAuth(firebase).currentUser.email,this.state.old);

                reauthenticateWithCredential(getAuth(firebase).currentUser, credential).then(() => {
                  reauthenticateWithCredential(getAuth(firebase).currentUser, credential).then(() => {

                    updatePassword(getAuth(firebase).currentUser,this.state.new).then(() => {
                      this.alert.onAlert({title:strings.newPasswordOK}); 
                      this.setState({waiting:false})
                      this.setState({viewMode:"normal"})
                      

                    }).catch((error) => {console.log(error);this.alert.onAlert({title:strings.errorDefault}); this.setState({waiting:false})});

                  }).catch((error) => {console.log(error); this.alert.onAlert({title:strings.errorDefault}); this.setState({waiting:false})
                });
              }).catch((error) => {console.log(error); this.alert.onAlert({title:strings.incorrectOldPassword}); this.setState({waiting:false})});

              }

            }
          }
        
      }
  }





  render() {
    return (
      <StyleContext.Consumer>{style => 
      
      <ScrollView style={{ marginLeft: 0, marginRight: 0, backgroundColor: style.backgroundColor,width: "100%",height: Dimensions.get('window').height, }}>
       

        {this.state.viewMode=="normal" && <View>


         {(Platform.OS=="web" && this.state.disableNavigation!=true) && <MavNavigationMinimize clickLeft={() => { this.state.params.goBack();  }} left={strings.return} title={ strings.account } />}



          {this.state.newClient==true && <MavInfoBubble type={"warning"} title={strings.warningManualAccount} subTitle={strings.warningManualAccountMoreInfo} style={{marginTop:10,}} />}











      

          {(this.state.adminView==true) && <View style={{backgroundColor:style.backgroundColorContrast, width:'100%'}}>


            <View style={{marginLeft:"10%", marginRight:"10%", marginTop:10,  flexDirection:"row", alignItems:"center"}}>

             {(this.state.partner==true) && <TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => { this.setState({viewPicture:true}) }} >
                <View style={{backgroundColor:style.backgroundColorContrast,  height:70, width:70,marginRight:10 }}>
                    <Image source={require('../assets/userBlank.png')} style={{ resizeMode:"contain", width:70, height:70,position:"absolute" }}/>
                    <Image source={{uri:"https://firebasestorage.googleapis.com/v0/b/"+info.firebaseProjectID+".appspot.com/o/partners%2F"+this.state.clientID+"%2Fpicture.jpg?alt=media"}} style={{borderRadius:(Platform.OS=="web")?"50%":35, width:70, height:70,position:"absolute" }}/>
                </View>
            </TouchableHighlight>}

            {(this.state.partner!=true) && <View style={{backgroundColor:style.backgroundColorContrast,  height:70, width:70,marginRight:10, backgroundColor:style.color1, borderRadius:(Platform.OS=="web")?"50%":35, }}>
                    <Image source={(this.state.manager==true)?( (style.mode=="dark")?require('../assets/user_manager_black.png'):require('../assets/user_manager_white.png')): ( (this.state.provider==true)?( (style.mode=="dark")?require('../assets/user_partner_black.png'):require('../assets/user_partner_white.png')):((this.state.customerPro==true)?( (style.mode=="dark")?require('../assets/user_pro_black.png'):require('../assets/user_pro_white.png')):  ( (style.mode=="dark")?require('../assets/user_black.png'):require('../assets/user_white.png'))))} style={{ resizeMode:"contain", marginLeft:10, marginTop:10, width:50, height:50,position:"absolute" }}/>
            </View>}

            <View>
                <Text style={{textAlign:"left", fontSize: style.textInputFontSize*1.2,color: style.textInputColor,fontWeight:"normal"}}> {this.state.name+" "} <Text style={{fontSize: style.textInputFontSize*1.2,color: style.textInputColor,fontWeight: 'bold'}}>{this.state.lastName.toUpperCase()}</Text></Text>
                {(this.state.enterprise!=undefined && this.state.enterprise!="") && <Text style={{textAlign:"left", fontSize: style.textInputFontSize,color: style.textInputColor,fontWeight:"normal"}}> {this.state.enterprise} </Text>}
                {(this.state.note==undefined && this.state.email!="" && this.state.email!=undefined) && <Text style={{textAlign:"left", fontSize: style.textInputFontSize*0.9,color: style.textInputColor,fontWeight:"normal"}}> {this.state.email} </Text>}

                {this.state.note!=undefined  && <TouchableHighlight underlayColor="rgba(0,0,0,0)" onPress={() => {
                      var pars={partner:this.state.partner, id:this.state.clientID,note:this.state.note, changeNoteReview:this.changeNoteReview};
                      if(Platform.OS=="web") this.props.params.navigate('NoteInfo',pars);
                      else this.props.navigation.navigate('NoteInfo',pars)  

                  }}>
                    <View style={{flexDirection:'row',marginBottom:10, alignItems:"center",justifyContent:"center"}}> 

                      <Image source={(this.state.note.note>0)?((style.mode=="dark")?require("../assets/star1_dark.png"):require("../assets/star1_light.png")): ((style.mode=="dark")?require("../assets/star2_dark.png"):require("../assets/star2_light.png") )} style={{width:20,height:20,marginRight:2,}}></Image>
                      <Image source={(this.state.note.note>1)?((style.mode=="dark")?require("../assets/star1_dark.png"):require("../assets/star1_light.png")): ((style.mode=="dark")?require("../assets/star2_dark.png"):require("../assets/star2_light.png") )} style={{width:20,height:20,marginRight:2,}}></Image>
                      <Image source={(this.state.note.note>2)?((style.mode=="dark")?require("../assets/star1_dark.png"):require("../assets/star1_light.png")): ((style.mode=="dark")?require("../assets/star2_dark.png"):require("../assets/star2_light.png") )} style={{width:20,height:20,marginRight:2,}}></Image>
                      <Image source={(this.state.note.note>3)?((style.mode=="dark")?require("../assets/star1_dark.png"):require("../assets/star1_light.png")): ((style.mode=="dark")?require("../assets/star2_dark.png"):require("../assets/star2_light.png") )} style={{width:20,height:20,marginRight:2,}}></Image>
                      <Image source={(this.state.note.note>4)?((style.mode=="dark")?require("../assets/star1_dark.png"):require("../assets/star1_light.png")): ((style.mode=="dark")?require("../assets/star2_dark.png"):require("../assets/star2_light.png") )} style={{width:20,height:20,marginRight:2,}}></Image>

                      <Text style={{color: style.textInputColor,fontSize: style.textInputFontSize*0.7,textAlign: "center",marginLeft:5}}>{"("+this.state.note.note+"/5 - "+this.state.note.reviews+" "+strings.reviews.toLowerCase()+")"}</Text>

                    </View>
                </TouchableHighlight>}

            </View>  


          </View>

          </View>}




          {(this.state.adminView==true) && <View style={{marginBottom:15, }}>

              <View style={{width:"100%", height:30, backgroundColor:style.backgroundColorContrast}}/>

              <View style={{ width:"100%", flexDirection:"row",justifyContent: 'center',alignItems:"flex-start", backgroundColor:style.backgroundColorContrast}}>

                  {(this.state.phone!="") && <MavMiniButton maximize={true} icon={(style.mode=="dark")?require('../assets/driver_phone_dark.png'):require('../assets/driver_phone_light.png')} text={(this.state.partner==true)?strings.callPartner:strings.callCustomer} onlyButton={true}  onPress={()=>{ Linking.openURL("tel:"+this.state.phone); }} />}

                  {(this.state.phone!="") && <MavMiniButton maximize={true} icon={(style.mode=="dark")?require('../assets/driver_message_dark.png'):require('../assets/driver_message_light.png')} text={strings.sendSMS} onlyButton={true}  onPress={()=>{ Linking.openURL("sms:"+this.state.phone); }} />}

                  {(this.state.phone!="") && <MavMiniButton maximize={true} icon={(style.mode=="dark")?require('../assets/whatsapp_dark.png'):require('../assets/whatsapp_light.png')} text={strings.sendWhatsapp} onlyButton={true}  onPress={()=>{ var phone=this.state.phone;
                    if(phone!=undefined && phone[0]==0 && info.countryCode=="fr") phone="33"+phone;
                    Linking.openURL('whatsapp://phone='+phone); }} />}

                  {(this.state.email!="") && <MavMiniButton maximize={true} icon={(style.mode=="dark")?require('../assets/driver_mail_dark.png'):require('../assets/driver_mail_light.png')} text={strings.sendMail} onlyButton={true}  onPress={()=>{ Linking.openURL("mailto:"+this.state.email); }} />}

                  
              </View>

              <View style={{width:"100%", height:15, backgroundColor:style.backgroundColorContrast, shadowOpacity: 0.3,shadowRadius:2,shadowOffset: {height: 2,width: 0},elevation:1}}/>


              {(this.state.globalUser==true && this.state.manualClient!=true && this.state.driverAppli!=true) && <View style={{ width:"100%", }}>

              <Text style={{marginTop:15,color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",}}>{strings.compteType}</Text>

              {(this.state.managerLock==true) && <MavInfoBubble type={"warning"} title={strings.warning} subTitle={strings.managerModifAccountType} style={{marginTop:10,}} />}

               <MavTextInput style={{marginTop:5}} textInputFlex={0.8} disabledText={true}  arrowCircle={true} arrow={true} arrowEnabled={this.state.provider==false && this.state.partner==false && this.state.customerPro==false && this.state.manager==false} textExplication={strings.customer} editable={(this.state.waiting==false && this.state.disabledChange==false && this.state.managerLock!=true) }  enableInfo={true}  textRight={""} onEnableInfo={() => { this.alert.onAlert({title:strings.customer, subTitle:strings.customerMoreInfo});  }} onChange={()=>{this.setState({manager:false,partner:false,provider:false,customerPro:false, }) }}/>
               <MavTextInput style={{marginTop:5}} textInputFlex={0.8} disabledText={true}  arrowCircle={true} arrow={true} arrowEnabled={this.state.provider==false && this.state.partner==false && this.state.customerPro==true && this.state.manager==false} textExplication={strings.customerPro} editable={(this.state.waiting==false && this.state.disabledChange==false && this.state.managerLock!=true) }  enableInfo={true}  textRight={""} onEnableInfo={() => { this.alert.onAlert({title:strings.customerPro, subTitle:strings.customerProMoreInfo});  }}onChange={()=>{this.setState({manager:false,partner:false,provider:false,customerPro:true, }) }}/>
               <MavTextInput style={{marginTop:5}} textInputFlex={0.8} disabledText={true}  arrowCircle={true} arrow={true} arrowEnabled={this.state.provider==true && this.state.partner==false && this.state.customerPro==false && this.state.manager==false} textExplication={strings.providerAffair} editable={(this.state.waiting==false && this.state.disabledChange==false && this.state.managerLock!=true) }  enableInfo={true}  textRight={""} onEnableInfo={() => { this.alert.onAlert({title:strings.providerAffair, subTitle:strings.providerMoreInfo});  }} onChange={()=>{this.setState({manager:false,partner:false,provider:true, customerPro:false }) }}/>
               <MavTextInput style={{marginTop:5}} textInputFlex={0.8} disabledText={true}  arrowCircle={true} arrow={true} arrowEnabled={this.state.provider==false && this.state.partner==true && this.state.customerPro==false && this.state.manager==false} textExplication={strings.partner} editable={(this.state.waiting==false && this.state.disabledChange==false && this.state.managerLock!=true) }  enableInfo={true}  textRight={""} onEnableInfo={() => { this.alert.onAlert({title:strings.partner, subTitle:strings.partnerMoreInfo});  }} onChange={()=>{this.setState({manager:false,partner:true,provider:false, customerPro:false }) }}/>
               <MavTextInput style={{marginTop:5}} textInputFlex={0.8} disabledText={true}  arrowCircle={true} arrow={true} arrowEnabled={this.state.provider==false && this.state.partner==false && this.state.customerPro==false && this.state.manager==true} textExplication={strings.manager} editable={(this.state.waiting==false && this.state.disabledChange==false && this.state.managerLock!=true) }  enableInfo={true}  textRight={""} onEnableInfo={() => { this.alert.onAlert({title:strings.manager, subTitle:strings.managerMoreInfo});  }} onChange={()=>{this.setState({manager:true,partner:false,provider:false, customerPro:false }) }}/>

               
              <Text style={{marginTop:15,marginBottom:10,color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",}}>{strings.infoPersonal}</Text>

              </View>}

          </View>}



          {this.state.driverAppli==true && <View>

              <Text style={{marginTop:15,color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",}}>{strings.compteType}</Text>

               <MavTextInput style={{marginTop:5}} textInputFlex={0.8} disabledText={true}  arrowCircle={true} arrow={true} arrowEnabled={this.state.partner==false} textExplication={strings.admin} editable={(this.state.waiting==false && this.state.disabledChange==false) }  onChange={()=>{this.setState({partner:false,provider:false }) }}/>
               <MavTextInput style={{marginTop:5}} textInputFlex={0.8} disabledText={true}  arrowCircle={true} arrow={true} arrowEnabled={this.state.partner==true} textExplication={strings.adminAndDriver} editable={(this.state.waiting==false && this.state.disabledChange==false) }  onChange={()=>{this.setState({partner:true,provider:false }) }}/>


              <Text style={{marginTop:15,marginBottom:10,color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",}}>{strings.infoPersonal}</Text>

              </View>}














          <MavTextInput style={{marginTop:5}} textInputFlex={2} editable={!this.state.waiting && !this.state.disabledChange && (this.state.adminView!=true || this.state.partnerWrite==true || this.state.globalUser==false)} text={this.state.name} textExplication={(this.state.adminView==true)?strings.name:strings.name} placeholder={example.name} accessibilityLabel={strings.writeValue} onChangeText={(text)=>{this.setState({name:text})}}/>
          <MavTextInput style={{marginTop:5}} textInputFlex={2} editable={!this.state.waiting && !this.state.disabledChange && (this.state.adminView!=true || this.state.partnerWrite==true || this.state.globalUser==false)} text={this.state.lastName} textExplication={(this.state.adminView==true)?strings.lastName:strings.lastName} placeholder={example.lastName} accessibilityLabel={strings.writeValue}  onChangeText={(text)=>{this.setState({lastName:text})}}/>
          
          {(this.state.createAccount==false && this.state.partner!=true) && <MavTextInput style={{marginTop:5}} textInputFlex={2} editable={!this.state.waiting && !this.state.disabledChange && (this.state.adminView!=true || this.state.partnerWrite==true || this.state.globalUser==false)} text={this.state.enterprise} textExplication={strings.enterprise} accessibilityLabel={strings.writeValue}  placeholder={example.company} onChangeText={(text)=>{this.setState({enterprise:text})}}/>}
          
          {(this.state.createAccount==false && this.state.partner!=true && this.state.adminView==true && this.state.enterprise!="" && this.state.enterprise!=undefined) && <MavTextInput style={{marginTop:5}} textInputFlex={2} editable={!this.state.waiting && !this.state.disabledChange && (this.state.adminView!=true || this.state.partnerWrite==true || this.state.globalUser==false)} text={this.state.tvaNumber} textExplication={strings.tvaNumber} accessibilityLabel={strings.writeValue}  placeholder={info.countryCode.toUpperCase()+" 999999999"} onChangeText={(text)=>{this.setState({tvaNumber:text})}}/>}
          
          {(this.state.createAccount==false && this.state.partner!=true && this.state.adminView==true && info.tvaPercentClassic!=0 && this.state.tvaNumber!="" && this.state.tvaNumber!=undefined && this.state.tvaNumber.length>2 && (this.state.tvaNumber[0].toUpperCase()!=info.countryCode[0].toUpperCase() || this.state.tvaNumber[1].toUpperCase()!=info.countryCode[1].toUpperCase() ) ) && <MavTextInput style={{marginTop:5}} textInputFlex={2} editable={!this.state.waiting && !this.state.disabledChange && (this.state.adminView!=true || this.state.partnerWrite==true || this.state.globalUser==false)} textExplication={strings.noVAT} disabledText={true}  arrow={true} arrowEnabled={this.state.noVAT} onChange={()=>{this.setState({noVAT:!this.state.noVAT}) }}/>}
          


          {(this.state.createAccount==false && this.state.partner!=true) && <MavTextInput style={{marginTop:5}} textInputFlex={2} editable={!this.state.waiting && !this.state.disabledChange && (this.state.adminView!=true || this.state.partnerWrite==true || this.state.globalUser==false)} text={this.state.adressBill} textExplication={strings.adressBill} accessibilityLabel={strings.writeValue}  placeholder={example.adress} onChangeText={(text)=>{this.setState({adressBill:text})}}/>}

          {(this.state.createAccount==false && this.state.partner!=true) && <MavTextInput style={{marginTop:5}} textInputFlex={2} editable={!this.state.waiting && !this.state.disabledChange && (this.state.adminView!=true || this.state.partnerWrite==true || this.state.globalUser==false)} text={this.state.cityBill} textExplication={strings.cityBill} accessibilityLabel={strings.writeValue}  placeholder={info.companyCity} onChangeText={(text)=>{this.setState({cityBill:text})}}/>}



          <MavTextInput style={{marginTop:5}} textInputFlex={2} editable={!this.state.waiting && !this.state.disabledChange && (this.state.adminView!=true || this.state.partnerWrite==true || this.state.globalUser==false)} text={this.state.phone} keyboardType={"numeric"} choosePhone={true} countryPhone={this.state.countryPhone} flagPhone={this.state.flagPhone} accessibilityLabel={strings.writeValue}  onChangeCountry={(info)=>{ this.setState({countryPhone:info.id,countryPhoneIID:info.idd,flagPhone:info.flag }) }} textExplication={(this.state.adminView==true)?strings.phone:strings.phone} placeholder={example.phone} onChangeText={(text)=>{this.setState({phone:text})}}/>
          

          <MavTextInput style={{marginTop:5}} textInputFlex={2} editable={!this.state.waiting && !this.state.disabledChange && (this.state.adminView==false ||  (this.state.manualClient==true || this.state.globalUser==false) ) } keyboardType={"email-address"}  text={this.state.email} textExplication={(this.state.adminView==true)?strings.email:strings.email} placeholder={example.email} accessibilityLabel={strings.writeValue}  onChangeText={(text)=>{
            var emailFinal=text;
            emailFinal=emailFinal.replace(/\s/g, '');
            this.setState({email:emailFinal, emailHasChanged: true})}}/>

           {(this.state.driverAppli==true && this.state.partner==false) && <MavTextInput style={{marginTop:5}} textInputFlex={0.8} disabledText={true}  arrow={true} arrowEnabled={this.state.adminNotRace} textExplication={strings.adminNotRaceForHim+"\n"+strings.clickMoreInfos} accessibilityLabel={strings.writeValue}  textExplicationOnPress={() => {this.alert.onAlert({title:strings.adminNotRaceForHim, subTitle:strings.adminNotRaceForHimMoreInfo}) }} onChange={()=>{this.setState({adminNotRace:!this.state.adminNotRace}) }}/>}

           {(this.state.createAccount==false && this.state.manualClient==false && this.state.adminView!=true && this.state.newClient!=true) && <MavTextInput style={{marginTop:5}} textInputFlex={0.8} disabledText={true} arrow={true} arrowEnabled={this.state.adsNotification==true} textExplication={strings.adsNotificationAutorize} editable={(this.state.waiting==false && this.state.disabledChange==false) }  onChange={()=>{this.setState({adsNotification:!this.state.adsNotification}); }}/>}



          {(this.state.admin==true && this.state.partner==true) && <View>

            <MavTextInput style={{marginTop:5}} textInputFlex={2} editable={!this.state.waiting && !this.state.disabledChange && (this.state.adminView!=true || this.state.partnerWrite==true || this.state.globalUser==false)} text={this.state.evtc} textExplicationMini={strings.facultatif} textExplication={strings.evtc} placeholder={"012345678901"} onChangeText={(text)=>{
              var evtc=text;
              evtc=evtc.replace(/\s/g, '');
              this.setState({evtc:evtc})
            }}/>
          

            <MavTextInput style={{marginTop:5}} textInputFlex={2} editable={!this.state.waiting && !this.state.disabledChange && (this.state.adminView!=true || this.state.partnerWrite==true || this.state.globalUser==false)} text={this.state.nloti} textExplicationMini={strings.facultatif} textExplication={strings.nloti} placeholder={"012345678901"} onChangeText={(text)=>{
              var nloti=text;
              nloti=nloti.replace(/\s/g, '');
              this.setState({nloti:nloti})
            }}/>
            

            {this.state.taxiMode==true && <MavTextInput style={{marginTop:5}} textInputFlex={2} editable={!this.state.waiting && !this.state.disabledChange && (this.state.adminView!=true || this.state.partnerWrite==true || this.state.globalUser==false)} text={this.state.ntaxi} textExplicationMini={strings.facultatif} textExplication={strings.ntaxi} placeholder={"012345678901"} onChangeText={(text)=>{
              var ntaxi=text;
              ntaxi=ntaxi.replace(/\s/g, '');
              this.setState({ntaxi:ntaxi})
            }}/>}

          </View>}


          
            {(this.state.adminView!=true && this.state.partner==true && !this.state.disabledChange) && <TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => {this.takePicture()}}>
              <MavTextInput style={{marginTop:15}} textInputFlex={2} textExplication={strings.changePicture} icon={(style.mode=="dark")?require('../assets/partner_dark.png'):require('../assets/partner_light.png')} disabledText={true}/>
          </TouchableHighlight>}


          


          {(this.state.createAccount==true) && <MavTextInput disableLine={true} style={{marginTop:5}} secureTextEntry={true} editable={(this.state.waiting==false && this.state.disabledChange==false) }  textInputFlex={2} text={this.state.password} enableViewPassword={true}  textExplication={strings.password} placeholder={"********"} onChangeText={(text)=>{this.setState({password:text})}}/>}

          {(this.state.createAccount==true) && <View style={{marginLeft:"10%", marginRight:"10%",}}>
                
                <Text style={{fontSize: style.textInputFontSize*0.8,color:(/[A-Z]/.test(this.state.password)==true)?style.colorValidate:style.textInputColor}}>{ ((/[A-Z]/.test(this.state.password)==true)?"✓ ":"- ")+strings.caractereMAJ}</Text>
                <Text style={{fontSize: style.textInputFontSize*0.8,color:(/[a-z]/.test(this.state.password)==true)?style.colorValidate:style.textInputColor}}>{ ((/[a-z]/.test(this.state.password)==true)?"✓ ":"- ")+strings.caractereMinus}</Text>
                <Text style={{fontSize: style.textInputFontSize*0.8,color:(/[0-9]/.test(this.state.password)==true)?style.colorValidate:style.textInputColor}}>{ ((/[0-9]/.test(this.state.password)==true)?"✓ ":"- ")+strings.caractereNumber}</Text>
                <Text style={{fontSize: style.textInputFontSize*0.8,color:(this.state.password.length>7)?style.colorValidate:style.textInputColor}}>{ ((this.state.password.length>7)?"✓ ":"- ")+strings.caractereMin}</Text>
                <View style={{height: style.textLineHeight,backgroundColor: style.textInputLineColor,marginTop: 10}}/>

            </View>}



             


          {((info.disableFavoriteDriverForCustomer==false || (this.state.adminView==true && info.disableFavoriteDriverForAdmin==false) ) && this.state.partner==false && this.state.manager==false && this.state.newClient==false && this.state.manualClient==false && !this.state.disabledChange ) && <TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => { this.viewPartner()}}>
              <MavTextInput onlyTextInputColor={(this.state.partnerSelected.id==-1)?style.placeholderTextInputColor:(style.textInputColor)} style={{marginTop:5}} textInputFlex={2} textExplication={strings.myDriver} text={this.state.partnerSelected.text} editable={false}/>
          </TouchableHighlight>}


          {(Platform.OS!="web" && !this.state.disabledChange && (this.state.provider==true || this.state.providerMyAccount==true)) && <TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => {
            if(Platform.OS=="web") this.setState({viewTrajet:true})
            else this.props.navigation.navigate('Trajet', {onFavoritePlace: this.onFavoritePlace, }); 
          }}>
              <MavTextInput style={{marginTop:5}} textInputFlex={2} textExplication={strings.adress} text={(this.state.adress==undefined || this.state.adress=="")?strings.selectFrom:this.state.adress.description} editable={false}/>
          </TouchableHighlight>}




          {(this.state.createAccount==true) && <MavTextInput style={{marginTop:5}} textInputFlex={0.8} disabledText={true}  arrow={true} arrowEnabled={this.state.cguAgree} textExplication={strings.cguAgree} editable={(this.state.waiting==false && this.state.disabledChange==false) }  textExplicationOnPress={() => {this.props.navigation.navigate('Conditions') }} onChange={()=>{
            if(this.state.waiting==false){
              if(this.state.cguAgree==true) this.setState({cguAgree:false}) 
              else this.setState({cguAgree:true}) } 
          }}/>}

          {(this.state.createAccount!=true && this.state.newClient!=true && this.state.adminView!=true) && <TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => {this.setState({viewMode:"changePassword"}); }}>
              <MavTextInput style={{marginTop:15}} textInputFlex={2} textExplication={strings.changePassword} icon={(style.mode=="dark")?require('../assets/lock_dark.png'):require('../assets/lock_light.png')} disabledText={true}/>
          </TouchableHighlight>}


          {(this.state.adminView==true && this.state.partner!=true && this.state.provider!=true && this.state.manager!=true  && this.state.globalUser==true) && <Text style={{marginTop:15,color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",}}>{strings.moreInfos}</Text>}




          {(this.state.adminView==true && this.state.partner!=true && this.state.provider!=true && this.state.manager!=true &&  this.state.globalUser==true) && <MavInfoBubble type={"info"} title={strings.customRace} subTitle={strings.customersNotePlaceorder} style={{marginTop:10,marginBottom:10}} />}

            

          {(this.state.adminView==true && this.state.partner!=true && this.state.provider!=true && this.state.manager!=true && this.state.globalUser==true) && <MavTextInput style={{marginTop:15}} text={this.state.usersMoreInfos} multiline={true} textExplication={strings.notes} placeholder={"Radio : France Info"} onChangeText={(text)=>{this.setState({usersMoreInfos:text})}}/>}

          {(this.state.adminView==true && this.state.partner!=true && this.state.provider!=true && this.state.manager!=true && this.state.globalUser==true) && <MavTextInput style={{marginTop:15}} text={this.state.usersMoreInfosDriver} multiline={true} textExplication={strings.notesForDriver} placeholder={"Client handicapé - prevoir chaise roulante"} onChangeText={(text)=>{this.setState({usersMoreInfosDriver:text})}}/>}




          {(this.state.admin==true && this.state.partner==true) && <Text style={{marginTop:15,marginBottom:10,color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",}}>{strings.carsDriver}</Text>}

          {(this.state.admin==true && this.state.partner==true && Object.keys(this.state.carModel).length==0) &&  <MavInfoBubble type={"info"} title={strings.noCarDefined} subTitle={strings.addCarDriverInfo} style={{marginTop:10,}} />}


          {(this.state.admin==true && this.state.partner==true) && Object.keys(this.state.carModel).map((rowData) => (
            <TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => {this.setState({carModalVisible:true, car:this.state.carModel[rowData], carID:rowData})  }} >
                <MavTextInput style={{marginTop:5}} textInputFlex={0.8} disabledText={true} textExplication={this.state.carModel[rowData].brand+" "+this.state.carModel[rowData].model}  enableRemove={true} onRemove={() => {
                  var cm={}
                  var i;
                  var obj=Object.keys(this.state.carModel)
                  for (i=0;i<obj.length;i++){
                    console.log("je fais "+i+" et je teste "+rowData)
                    if(i!=rowData) cm[Object.keys(cm).length]=this.state.carModel[obj[i]];
                  }
                  console.log(cm)
                  this.setState({carModel:cm})

                }} />
            </TouchableHighlight>

          ))}



          {(this.state.admin==true && this.state.partner==true) && <View style={{alignItems:"center",justifyContent:"center", marginTop:30}}><MavButton text={strings.add} onlyButton={true} onPress={()=>{ this.setState({carModalVisible:true, car:{},carID:"" })   }}/></View>}

          {(this.state.admin==true && this.state.partner==true) && <View
              style={{
                height: style.textLineHeight,
                backgroundColor: style.textInputLineColor,
                marginTop: style.textInputMarginTop+10,
                marginLeft:"5%",
                width: "90%",
              }}
            />}







           {(this.state.admin==true && this.state.manager==true) && <MavInfoBubble type={"info"} title={strings.roles} subTitle={strings.rolesManagerMoreInfo} style={{marginTop:10,marginBottom:10}} />}
          
          {(this.state.admin==true && this.state.manager==true && this.state.managerLock==true) && <MavInfoBubble type={"warning"} title={strings.warning} subTitle={strings.managerModifAccountManage} style={{marginTop:10,}} />}

          {(this.state.admin==true && this.state.manager==true ) && <MavTextInput style={{marginTop:5}} textInputFlex={0.8} disabledText={true}  arrow={true} arrowEnabled={(this.state.managerInfo.dispatch==true)?true:false} textExplication={strings.dispatch} editable={(this.state.waiting==false && this.state.disabledChange==false && this.state.managerLock!=true) }  onChange={()=>{
            var maI=JSON.parse(JSON.stringify(this.state.managerInfo)); if(maI.dispatch==true) delete maI.dispatch; else maI.dispatch=true; this.setState({managerInfo:maI})
          }}/>}

          {(this.state.admin==true && this.state.manager==true) && <MavTextInput style={{marginTop:5}} textInputFlex={0.8} disabledText={true}  arrow={true} arrowEnabled={(this.state.managerInfo.settings==true)?true:false} textExplication={strings.settings} editable={(this.state.waiting==false && this.state.disabledChange==false && this.state.managerLock!=true) }  onChange={()=>{
            var maI=JSON.parse(JSON.stringify(this.state.managerInfo)); if(maI.settings==true) delete maI.settings; else maI.settings=true; this.setState({managerInfo:maI})
          }}/>}

          {(this.state.admin==true && this.state.manager==true) && <MavTextInput style={{marginTop:5}} textInputFlex={0.8} disabledText={true}  arrow={true} arrowEnabled={(this.state.managerInfo.revenu==true)?true:false} textExplication={strings.revenue} editable={(this.state.waiting==false && this.state.disabledChange==false && this.state.managerLock!=true) }  onChange={()=>{
            var maI=JSON.parse(JSON.stringify(this.state.managerInfo)); if(maI.revenu==true) delete maI.revenu; else maI.revenu=true; this.setState({managerInfo:maI})
          }}/>}

          {(this.state.admin==true && this.state.manager==true) && <MavTextInput style={{marginTop:5}} textInputFlex={0.8} disabledText={true}  arrow={true} arrowEnabled={(this.state.managerInfo.phonebook==true)?true:false} textExplication={strings.repertoire} editable={(this.state.waiting==false && this.state.disabledChange==false && this.state.managerLock!=true) }  onChange={()=>{
            var maI=JSON.parse(JSON.stringify(this.state.managerInfo)); if(maI.phonebook==true) delete maI.phonebook; else maI.phonebook=true; this.setState({managerInfo:maI})
          }}/>}


          {(this.state.admin==true && this.state.partner==true) && <Text style={{marginTop:15,marginBottom:10,color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",}}>{strings.carAuthorised}</Text>}
          

          {(this.state.admin==true && this.state.partner==true && Object.keys(this.state.carList).length==0) &&  <MavInfoBubble type={"warning"} title={strings.definePriceOnSettings} subTitle={strings.definePriceOnSettingsMoreInfo} style={{marginTop:10,}} />}

          {(this.state.admin==true && this.state.partner==true && Object.keys(this.state.carList).length>0) &&  <MavInfoBubble type={"info"} title={strings.selectOneCarMin} subTitle={strings.carExplicationComplex} style={{marginTop:10,marginBottom:10}} />}








          
          {(this.state.admin==true && this.state.partner==true) && Object.keys(this.state.carList).map((rowData) => (

            <MavTextInput style={{marginTop:5}} textInputFlex={0.8} disabledText={true}  arrow={true} arrowEnabled={this.state.carList[rowData]} textExplication={rowData} editable={(this.state.waiting==false && this.state.disabledChange==false) }  onChange={()=>{
                  var carList=this.state.carList;
                  carList[rowData]=(carList[rowData]==true)?false:true;
                  this.setState({carList:carList})
            }}/>
          ))}




          


          {(this.state.admin==true && this.state.partner==true) && <Text style={{marginTop:15,color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",}}>{strings.zoneWork}</Text>}

          {(this.state.admin==true && this.state.partner==true && Object.keys(this.state.pricingList).length==0) &&  <MavInfoBubble type={"warning"} title={strings.definePriceOnSettings} subTitle={strings.definePriceOnSettingsMoreInfo} style={{marginTop:10,}} />}

          {(this.state.admin==true && this.state.partner==true && Object.keys(this.state.pricingList).length>0) &&  <MavInfoBubble type={"info"} title={strings.selectOneZoneMin} subTitle={strings.zoneWorkExplication} style={{marginTop:10,marginBottom:10}} />}



          {(this.state.admin==true && this.state.partner==true) && Object.keys(this.state.pricingList).map((rowData) => (

            <MavTextInput style={{marginTop:5}} textInputFlex={0.8} disabledText={true}  arrow={true} arrowEnabled={this.state.noZone[rowData]!=undefined?false:true} textExplication={this.state.pricingList[rowData].text} editable={(this.state.waiting==false && this.state.disabledChange==false) }  onChange={()=>{
                    var zo=this.state.noZone;
                  if(this.state.noZone[rowData]!=undefined){delete zo[rowData]}
                  else {zo[rowData]=true;} 
                   this.setState({noZone:zo})
                  
            }}/>
          ))}


          {(this.state.admin==true && this.state.partner==true) && <View>

            <Text style={{marginTop:15,color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",}}>{strings.languageOkay}</Text>
            
            <MavInfoBubble type={"info"} title={strings.selectOneLangueMin} subTitle={strings.languageOkayMoreInfo} style={{marginTop:10,marginBottom:10}} />



            

            {strings.languageAvaiable.map((rowData,i) => (
                <MavTextInput style={{marginTop:5}} textInputFlex={0.8} disabledText={true}  arrow={true} arrowEnabled={this.state.noLanguage[rowData.id]!=undefined?false:true} textExplication={rowData.text} editable={(this.state.waiting==false && this.state.disabledChange==false) }  onChange={()=>{
                    var zo=this.state.noLanguage;
                  if(this.state.noLanguage[rowData.id]!=undefined){delete zo[rowData.id]}
                  else {zo[rowData.id]=true;} 
                   this.setState({noLanguage:zo})
                  
            }}/>

            ))}


            {(this.state.options!=undefined && Object.keys(this.state.options).length>0) && <View>
                <Text style={{marginTop:15,color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",}}>{strings.optionsOkay}</Text>
                <MavInfoBubble type={"info"} title={strings.selectOption} subTitle={strings.OptionsOkayMoreInfo} style={{marginTop:10,marginBottom:10}} />



                {Object.keys(this.state.options).map((rowData,i) => (
                <View>
                  {this.state.options[rowData]==true && <MavTextInput style={{marginTop:5}} textInputFlex={0.8} disabledText={true}  arrow={true} arrowEnabled={ (this.state.acceptedOptions[rowData]==true)?true:false   } textExplication={strings["accept"+rowData.charAt(0).toUpperCase() + rowData.slice(1) ]} editable={(this.state.waiting==false && this.state.disabledChange==false) }  onChange={()=>{ 
                      var zo=this.state.acceptedOptions;
                      if(zo[rowData]===undefined) zo[rowData]=true;
                      else delete zo[rowData]
                      this.setState({acceptedOptions:zo})
                  }}/>}
                </View>

            ))}





            </View>}



            


            {this.state.driverAppli!=true && <View>

            <Text style={{marginTop:15,color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",}}>{strings.privilegeDriver}</Text>
            
            <MavInfoBubble type={"info"} title={strings.selectLevel} subTitle={strings.privilegeDriverMoreInfo} style={{marginTop:10,marginBottom:10}} />

            {strings.privilegeDriverAvaiable.map((rowData,i) => (
              <MavTextInput style={{marginTop:5}} textInputFlex={0.8} disabledText={true}  arrowCircle={true} arrow={true} arrowEnabled={this.state.privilegeDriver==rowData.id} textExplication={rowData.text} editable={(this.state.waiting==false && this.state.disabledChange==false) }  onChange={()=>{this.setState({privilegeDriver:rowData.id }) }}/>


            ))}



            <Text style={{marginTop:15,color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",}}>{strings.viewPhone}</Text>
            {strings.viewPhoneAvaiable.map((rowData,i) => (
              <MavTextInput style={{marginTop:5}} textInputFlex={0.8} disabledText={true}  arrowCircle={true} arrow={true} arrowEnabled={this.state.viewPhone==rowData.id} textExplication={rowData.text} editable={(this.state.waiting==false && this.state.disabledChange==false) }  onChange={()=>{this.setState({viewPhone:rowData.id }) }}/>


            ))}

            </View>}




            <Text style={{marginTop:15,color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",}}>{strings.bill}</Text>

            <MavInfoBubble type={"info"} title={strings.manageBill} subTitle={strings.manageBillMoreInfo} style={{marginTop:10,marginBottom:10}} />

            <MavTextInput style={{marginTop:5}} textInputFlex={0.8} disabledText={true}  arrowCircle={true} arrow={true} arrowEnabled={this.state.billMode=="appCompany"} textExplication={strings.billAtMyName} editable={(this.state.waiting==false && this.state.disabledChange==false) }  onChange={()=>{this.setState({billMode:"appCompany"})}}/>
            {<MavTextInput style={{marginTop:5}} textInputFlex={0.8} disabledText={true}  arrowCircle={true} arrow={true} arrowEnabled={this.state.billMode=="partnerCompany"} textExplication={strings.billAtThisName} editable={(this.state.waiting==false && this.state.disabledChange==false) }  onChange={()=>{this.setState({billMode:"partnerCompany"})}}/>}
            <MavTextInput style={{marginTop:5}} textInputFlex={0.8} disabledText={true}  arrowCircle={true} arrow={true} arrowEnabled={this.state.billMode=="double"} textExplication={strings.doubleBill} editable={(this.state.waiting==false && this.state.disabledChange==false) }  onChange={()=>{this.setState({billMode:"double"})}}/>




            {(this.state.billMode=="partnerCompany" || this.state.billMode=="double") && <MavViewMore style={{marginTop:15}} defautVisible={true} text={ strings.enterpriseInfo } iconClassic={(style.mode=="dark")?require('../assets/driver_bon_light.png'):require('../assets/driver_bon_dark.png')} >




                <MavTextInput style={{marginTop:15}} backgroundColor={style.backgroundColorContrast} keyboardType={"numeric"} text={this.state.commission} textExplicationOnPress={(text)=>{this.alert.onAlert({title:strings.commission, subTitle:strings.commissionDriverExplication}) }} textExplicationMini={strings.moreInfos} textExplication={strings.commission} placeholder={"15%"} onChangeText={(text)=>{
                  text=text.replace(",",'.');
                  text=text.replace("%",'');
                  
                  this.setState({commission:text})
                  timer.setTimeout("eee", () => {
                    var t=parseFloat(this.state.commission);
                    t=t.toString()
                    if(t==="NaN") t="";
                    else t+="%";
                    this.setState({commission:t})
                  }, 2000);

                }}/>


                {(this.state.billMode!="appCompany" && (this.state.commission=="0%" || this.state.commission=="0")) && <Text style={{marginTop:5,color:"#E32400",marginLeft:"10%", marginRight:"10%", fontSize: style.textInputFontSize*0.8,textAlign: "center",}}>{strings.commissionZero}</Text>}

                {this.state.billMode=="partnerCompany" && <MavTextInput style={{marginTop:5}} backgroundColor={style.backgroundColorContrast} textInputFlex={0.8} disabledText={true}  arrow={true} arrowEnabled={(this.state.partnerCompanyWithCommission==true)?false:true} textExplication={strings.partnerCompanyWithCommission} editable={(this.state.waiting==false && this.state.disabledChange==false) }  onChange={()=>{ this.setState({partnerCompanyWithCommission:(this.state.partnerCompanyWithCommission==true)?false:true});     }}/>}


                {<MavTextInput style={{marginTop:5}} backgroundColor={style.backgroundColorContrast} text={this.state.companyBrand} textExplication={strings.companyName} placeholder={"Prestige VTC"} onChangeText={(text)=>{this.setState({companyBrand:text})}}/>}
                {<MavTextInput style={{marginTop:5}} backgroundColor={style.backgroundColorContrast} text={this.state.companyName} textExplication={strings.companyNameComplete} placeholder={"Prestige VTC SAS au capital de 5000€"} onChangeText={(text)=>{this.setState({companyName:text})}}/>}
                {<MavTextInput style={{marginTop:5}} backgroundColor={style.backgroundColorContrast} text={this.state.companyAdress} textExplication={strings.companyAdress} placeholder={"40 Chemin de la République"} onChangeText={(text)=>{this.setState({companyAdress:text})}}/>}
                
                {<MavTextInput style={{marginTop:5}} backgroundColor={style.backgroundColorContrast} text={this.state.companyCity} textExplication={strings.companyCity} placeholder={"75000 Paris"} onChangeText={(text)=>{this.setState({companyCity:text})}}/>}
                {<MavTextInput style={{marginTop:5}} backgroundColor={style.backgroundColorContrast} text={this.state.companyEmail} textExplication={strings.email} placeholder={"vtc@mail.com"} onChangeText={(text)=>{this.setState({companyEmail:text})}}/>}
                {<MavTextInput style={{marginTop:5}} backgroundColor={style.backgroundColorContrast} text={this.state.companySiret} textExplication={strings.companySiret} placeholder={"80090070000010"} onChangeText={(text)=>{this.setState({companySiret:text})}}/>}
                {<MavTextInput style={{marginTop:5}} backgroundColor={style.backgroundColorContrast} text={this.state.rcs} textExplication={strings.rcs} placeholder={"RCS Paris 600 900 300"} onChangeText={(text)=>{this.setState({rcs:text})}}/>}
                
                {<MavTextInput style={{marginTop:5}} backgroundColor={style.backgroundColorContrast} text={this.state.assuranceName} textExplication={strings.assuranceName} placeholder={"Maaf Assurance"} onChangeText={(text)=>{this.setState({assuranceName:text})}}/>}
                {<MavTextInput style={{marginTop:5}} backgroundColor={style.backgroundColorContrast} text={this.state.assuranceNumber} textExplication={strings.assuranceNumber} placeholder={"123456789"} onChangeText={(text)=>{this.setState({assuranceNumber:text})}}/>}

                {<MavTextInput style={{marginTop:5}} disableLine={!this.state.tvaAdmission} backgroundColor={style.backgroundColorContrast} textInputFlex={0.8} disabledText={true}  arrow={true} arrowEnabled={this.state.tvaAdmission} textExplication={strings.subjectToTVA} editable={(this.state.waiting==false && this.state.disabledChange==false) }  onChange={()=>{if(this.state.tvaAdmission===true) this.setState({forceTVAPercent:false}) ; this.setState({tvaAdmission:!this.state.tvaAdmission});     }}/>}

                {(this.state.tvaAdmission==true) && <MavTextInput style={{marginTop:5}} backgroundColor={style.backgroundColorContrast} text={this.state.tvaNumber} textExplication={strings.tvaNumber} placeholder={info.countryCode.toUpperCase()+" 999999999"} onChangeText={(text)=>{this.setState({tvaNumber:text})}}/>}

                {(this.state.tvaAdmission==true ) && <MavTextInput style={{marginTop:5}} disableLine={!this.state.forceTVAPercent} backgroundColor={style.backgroundColorContrast} textInputFlex={0.8} disabledText={true}  arrow={true} arrowEnabled={this.state.forceTVAPercent} textExplication={strings.forceTVAPercent} editable={(this.state.waiting==false && this.state.disabledChange==false) }  onChange={()=>{this.setState({forceTVAPercent:!this.state.forceTVAPercent})}}/>}



                {(this.state.forceTVAPercent==true ) && <MavTextInput style={{marginTop:5}} backgroundColor={style.backgroundColorContrast} keyboardType={"numeric"} text={this.state.tvaPercentClassic} textExplication={strings.tvaRace} placeholder={"10%"} onChangeText={(text)=>{
                  var r=parseInt(text);r=r.toString();if(r==="NaN") r="";this.setState({tvaPercentClassic:r})
                  timer.setTimeout("tvaPercentClassic", () => {
                    var t=parseInt(this.state.tvaPercentClassic); t=t.toString()
                    if(t==="NaN") t=""; else t+="%";
                    this.setState({tvaPercentClassic:t})
                  }, 2000);

                }}/>}

                {(this.state.forceTVAPercent==true ) && <MavTextInput style={{marginTop:5}} disableLine={true} backgroundColor={style.backgroundColorContrast} keyboardType={"numeric"} text={this.state.tvaPercentDispo} textExplication={strings.tvaDispo} placeholder={"10%"} onChangeText={(text)=>{
                  var r=parseInt(text);r=r.toString();if(r==="NaN") r="";this.setState({tvaPercentDispo:r})
                  timer.setTimeout("tvaPercentDispo", () => {
                    var t=parseInt(this.state.tvaPercentDispo); t=t.toString()
                    if(t==="NaN") t=""; else t+="%";
                    this.setState({tvaPercentDispo:t})
                  }, 2000);

                }}/>}

                

                {(info.stripePublicKey!=undefined && true ) &&  <TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => { this.generateStripeConnect()  }}>

                    <MavTextInput style={{marginTop:15}} backgroundColor={style.backgroundColorContrast} iconWait={(this.state.waitGenerateStripeConnect==true)?true:false} textInputFlex={2}  textExplicationMini={strings.createLinkSripeConnectMoreInfo} textExplication={strings.createLinkSripeConnect} icon={(style.mode=="dark")?require('../assets/revenue_change_black.png'):require('../assets/revenue_change_white.png')} disabledText={true}/>

                </TouchableHighlight> }  


          </MavViewMore>}


          </View>}




          {(this.state.provider==true) && <View>

          <Text style={{marginTop:15,color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",}}>{strings.privilegeProvider}</Text> 
          <MavInfoBubble type={"info"} title={strings.selectLevel} subTitle={strings.privilegeProviderMoreInfo} style={{marginTop:10,marginBottom:10}} />

            {strings.privilegeProviderAvaiable.map((rowData,i) => (
              <MavTextInput style={{marginTop:5}} textInputFlex={0.8} disabledText={true}  arrowCircle={true} arrow={true} arrowEnabled={this.state.privilegeProvider==rowData.id} textExplication={rowData.text} editable={(this.state.waiting==false && this.state.disabledChange==false) }  onChange={()=>{this.setState({privilegeProvider:rowData.id });  }}/>


            ))}

        </View>}




          
          

          {(this.state.admin==true && this.state.partner==false && this.state.manager!=true  && this.state.manualClient==false) && <Text style={{marginTop:15,color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",}}>{strings.blacklistedDriver}</Text>}
          {(this.state.admin==true && this.state.partner==true && this.state.manager!=true && this.state.manualClient==false ) && <Text style={{marginTop:15,color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",}}>{strings.blacklistedClient}</Text>}
          
          {(this.state.admin==true && this.state.manager!=true && this.state.manualClient==false) && <MavInfoBubble type={"info"} title={strings.problemClientDriver} subTitle={strings.problemClientDriverMoreInfo} style={{marginTop:10,marginBottom:10}} />}
          
          {(this.state.admin==true && this.state.partner==true && this.state.manager!=true && this.state.manualClient==false && this.state.blackList.length==0) && <Text style={{marginTop:5,color: style.textInputColor,fontSize: style.textInputFontSize*0.8,textAlign: "center",}}>{strings.noClientBlacklisted}</Text>}
          {(this.state.admin==true && this.state.partner==false && this.state.manager!=true  && this.state.manualClient==false && this.state.blackList.length==0) && <Text style={{marginTop:5,color: style.textInputColor,fontSize: style.textInputFontSize*0.8,textAlign: "center",}}>{strings.noDriverBlacklisted}</Text>}

          {(this.state.blackList.length>0 && !this.state.disabledChange && this.state.manager!=true ) && this.state.blackList.map((rowData,i) => (
              <MavTextInput style={{marginTop:5}} disabledText={true} enableRemove={true} textExplication={rowData.text} onRemove={()=>{
                    var blak=this.state.blackList;
                    blak.splice(i,1); 
                    this.setState({blaklist:blak})
                    

              }}/>

          ))}


          {(this.state.admin==true && info.mavOffer=="multi" && this.state.manager!=true && this.state.manualClient==false && this.state.params.findClientById===undefined) && <View style={{alignItems:"center",justifyContent:"center", marginTop:30}}><MavButton text={strings.add} onlyButton={true} onPress={()=>{ this.viewBlackListPicker();}}/></View>}

          {(this.state.admin==true && info.mavOffer=="multi" && this.state.manager!=true && this.state.manualClient==false && this.state.params.findClientById===undefined) && <View
              style={{
                height: style.textLineHeight,
                backgroundColor: style.textInputLineColor,
                marginTop: style.textInputMarginTop+10,
                marginLeft:"5%",
                width:"90%",
              }}
            />}


          


          {(this.state.adminView==true && this.state.globalUser==true && this.state.manager!=true ) && <Text style={{marginTop:15,color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",}}>{strings.options}</Text>}


          {(this.state.adminView==true && this.state.partner!=true && this.state.manualClient==false && this.state.manager!=true ) && <MavTextInput style={{marginTop:5}}  editable={!this.state.waiting && (this.state.adminView!=true || this.state.partnerWrite==true)} text={this.state.permananteReduction} textExplication={strings.permananteReduction} placeholder={"10%"} onChangeText={(text)=>{
            text=text.replace(",",'.');
            text=parseFloat(text);
            if(isNaN(text)) text=""
            this.setState({permananteReduction:text.toString()})

            timer.setTimeout(generateUUID(), () => {
              var test=this.state.permananteReduction;
              if(test!=""){
                test=parseFloat(test);
                if(isNaN(test)) test=""
                test+="%"
              this.setState({permananteReduction:test})

              }
            }, 3500);
          }}/>
          }

          {(this.state.adminView==true && this.state.partner!=true && this.state.manualClient==false && this.state.provider==true ) && <MavTextInput style={{marginTop:5}} editable={!this.state.waiting && (this.state.adminView!=true || this.state.partnerWrite==true)} text={this.state.providerCommission} textExplication={strings.providerCommission} placeholder={"10%"} onChangeText={(text)=>{
            text=text.replace(",",'.');
            text=parseFloat(text);
            if(isNaN(text)) text=""
            this.setState({providerCommission:text.toString()})

            timer.setTimeout(generateUUID(), () => {
              var test=this.state.providerCommission;
              if(test!=""){
                test=parseFloat(test);
                if(isNaN(test)) test=""
                test+="%"
              this.setState({providerCommission:test})

              }
            }, 3500);
          }}/>
          }

          

          

          {(this.state.adminView==true && !this.state.disabledChange && this.state.partner!=true && this.state.manager!=true ) && <MavTextInput style={{marginTop:5}} textInputFlex={0.8} disabledText={true} arrow={true} arrowEnabled={this.state.deferredPayment==true} textExplication={strings.deferredPayment} editable={(this.state.waiting==false && this.state.disabledChange==false) }  onChange={()=>{this.setState({deferredPayment:!this.state.deferredPayment}); }}/>}

          {(this.state.adminView==true && !this.state.disabledChange && this.state.vipMode==true && this.state.manualClient==false && this.state.manager!=true   ) && <MavTextInput style={{marginTop:5}} textInputFlex={0.8} disabledText={true} arrow={true} arrowEnabled={this.state.vip==true} textExplication={strings.vip.toUpperCase()} editable={(this.state.waiting==false && this.state.disabledChange==false) }  onChange={()=>{this.setState({vip:!this.state.vip})}}/>}

          {(this.state.adminView==true && this.state.admin==true && this.state.partner==true && (info.customerChoicePartner==true || info.disableFavoriteDriverForAdmin==false || info.disableFavoriteDriverForCustomer==false )) && <MavTextInput style={{marginTop:5}} textInputFlex={0.8} disabledText={true} arrow={true} arrowEnabled={this.state.favForbidden==true} textExplication={strings.favoriteDriverNotPossible} textExplicationMini={strings.favoriteDriverNotPossibleMoreInfo} editable={(this.state.waiting==false && this.state.disabledChange==false) }  onChange={()=>{this.setState({favForbidden:!this.state.favForbidden})}}/>}
          


          {(this.state.adminView==true && this.state.globalUser==true && this.state.manager!=true && this.state.defineColorForCustomer==true && this.state.colorCustomer!=undefined ) && <TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => {  this.alert.onAlert({title:strings.selectColor, subTitle:strings.explicationHexaColor,  choiceColor:true, textInput:{text:(this.state.colorCustomer==false)?"#FFFFFF":this.state.colorCustomer,sizeMultiplicator:1.5,placeholder:"(ex : #FF0000)"}, help:{title:strings.selectColor, subTitle:strings.explicationHexaColorMoreInfo, url:"https://fr.wikipedia.org/wiki/Couleur_du_Web" },buttons:[{text: strings.validate,onPress: (value) => { this.changeCustomerColor(value); }}, {text: strings.cancel, style:"cancel",onPress: () => {}}],}) }}>

              <MavTextInput style={{marginTop:5}} textInputFlex={0.8} disabledText={true} statusModeMini={(this.state.colorCustomer==false)?"grey":this.state.colorCustomer} textExplication={(this.state.colorCustomer==false)?strings.giveColorCustomer:strings.colorCustomer}/>

          </TouchableHighlight>}



          {(this.state.adminView==true && !this.state.disabledChange && this.state.admin==true && this.state.manager!=true ) && <TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => { var obj={};if(this.state.partner==true) {obj.partnerID=this.state.clientID; obj.partnerText=this.state.name+" "+this.state.lastName; obj.driver=true;  if(Platform.OS=="web") this.props.params.navigate('Revenue',obj); else   this.props.navigation.navigate("Revenue",obj)} else {obj.userID=this.state.clientID; obj.adminView=this.state.adminView==true;  if(Platform.OS=="web") this.props.params.navigate('Booking',obj); this.props.navigation.navigate("Booking",obj);}  }}>
            <MavTextInput style={{marginTop:15}} textInputFlex={2} textExplication={strings.viewRace} icon={(style.mode=="dark")?require('../assets/route_dark.png'):require('../assets/route_light.png')} disabledText={true}/>
          </TouchableHighlight>}


          {(this.state.adminView==true && !this.state.disabledChange && this.state.admin==true && this.state.manager!=true  &&  this.state.globalUser==true && this.state.manualClient!=true && this.state.driverAppli!=true && this.state.partner==true && this.state.driverPricing==true) && <TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => { 

            var obj={view:"onlyPrice", driverPricing:true, viewAdmin:true, driverID:this.state.clientID}
            if(Platform.OS=="web") this.props.params.navigate('PricePlace',obj); 
            else this.props.navigation.navigate("PricePlace",obj)

           }}>
            <MavTextInput style={{marginTop:15}} textInputFlex={2} textExplication={strings.viewDriverPricing} icon={(style.mode=="dark")?require('../assets/settings_black.png'):require('../assets/settings_white.png')} disabledText={true}/>
          </TouchableHighlight>}



          {((this.state.adminView==true && !this.state.disabledChange && this.state.admin==true && this.state.manager!=true  && this.state.globalUser==true && this.state.manualClient!=true && this.state.driverAppli!=true && this.state.partner==false) || (this.state.autorizeChangeDriverFavoritePrice==true && this.state.disabledChange==true) ) && <TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => { 

            var obj={view:"onlyPrice", customerPricing:true, customerID:this.state.clientID}
            if(Platform.OS=="web") this.props.params.navigate('PricePlace',obj); 
            else this.props.navigation.navigate("PricePlace",obj)

           }}>
            <MavTextInput style={{marginTop:15}} textInputFlex={2} textExplication={strings.definePrice} icon={(style.mode=="dark")?require('../assets/settings_black.png'):require('../assets/settings_white.png')} disabledText={true}/>
          </TouchableHighlight>}




          {(this.state.adminView==true && !this.state.disabledChange && this.state.admin==true && this.state.globalUser==true && this.state.manualClient!=true && (this.state.partner==true || this.state.provider==true || this.state.customerPro == true )  ) && <TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => { 

              this.setState({viewClients:true})
             

           }}>
            <MavTextInput style={{marginTop:15}} textInputFlex={2} textExplication={strings.seeThisPhonebook} icon={(style.mode=="dark")?require('../assets/phoneBook_black.png'):require('../assets/phoneBook_white.png')} disabledText={true}/>
          </TouchableHighlight>}








          {(this.state.adminView==true && this.state.creditCustomer==undefined && this.state.manager!=true  && !this.state.disabledChange && info.paymentCardApp===true && this.state.admin==true && this.state.globalUser==true && this.state.manualClient!=true && this.state.driverAppli!=true && this.state.partner==false) && <TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => { this.viewClientCredit()  }}>
            <MavTextInput style={{marginTop:15}} iconWait={(this.state.waitCreditCustomer==true)?true:false} textInputFlex={2} textExplication={strings.seeCreditCustomer} icon={(style.mode=="dark")?require('../assets/cardCB_black.png'):require('../assets/cardCB_white.png')} disabledText={true}/>
          </TouchableHighlight>}

          {this.state.creditCustomer!=undefined && <MavViewMore style={{marginTop:15}} defautVisible={true} text={ strings.seeCreditCustomer } icon={(style.mode=="dark")?require('../assets/cardCB_black.png'):require('../assets/cardCB_white.png')} iconClassic={(style.mode=="dark")?require('../assets/cardCB_white.png'):require('../assets/cardCB_black.png')} >
              {this.state.creditCustomer.map((rowData,i) => (
                  <TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => { this.changeCredit(rowData,i) }}>
                      <MavTextInput style={{marginTop:5}} textInputFlex={1.5} disableLine={(i==(this.state.creditCustomer.length-1))?true:false} disabledText={true} textRight={((rowData.position=="left")?(rowData.symbole+" "):"")+rowData.amount+((rowData.position=="right")?(rowData.symbole):"")} textExplication={rowData.name} textExplicationMini={strings.modify} iconClassic={rowData.flag} backgroundColor={style.backgroundColorContrast} />
                  </TouchableHighlight>

              ))}
          </MavViewMore>}


            


   





          {(this.state.waiting==false && !this.state.disabledChange) && <View style={{alignItems:"center",justifyContent:"center", marginTop:30, marginBottom:(this.state.newClient==true)?300:null}}> 
              <MavButton onlyButton={true} text={strings.confirm} onPress={()=>{ 
              if(this.state.newClient===true) this.createManualClient();
              else if(this.state.createAccount) this.createAccount();
              else if(this.state.adminView!=true && this.state.emailHasChanged==true){
                this.alert.onAlert({title:strings.thanksPassword,textInput:{placeholder:strings.password,text:"", secureTextEntry:true},buttons:[{text:strings.ok,onPress: (value) => {
                  
                  const credential = EmailAuthProvider.credential(getAuth(firebase).currentUser.email,value);

                  reauthenticateWithCredential(getAuth(firebase).currentUser, credential).then(() => {this.updateAccount(); })
                  .catch((error) => {this.alert.onAlert({title:strings.incorrectEmailPassword});})

                }},{text: strings.cancel, style:"cancel",onPress: () => {}} ],});
                

              }
              else this.updateAccount();

            }}/>
            </View>}


            

          {this.state.waiting==true && <ActivityIndicator style={{marginTop:30,marginBottom:50}} size="large" color={style.color1} />}


          {(this.state.newClient==false && this.state.createAccount==false && !this.state.disabledChange) && <View style={{alignItems:"center",justifyContent:"center", marginTop:15,marginBottom:15}}> 

            <MavButton text={(this.state.adminView==true && this.state.manualClient==false)?( (this.state.accountClientDisabled==true)?strings.unlock:strings.lock    ):strings.remove} strokeMode={true} color={style.color1} onlyButton={true} onPress={()=>{
            if(this.state.adminView==true){
              if(this.state.manualClient==true){
                console.log("on supprime le client "+this.state.clientID)
                if(this.state.clientID!=""){

                    const fireInfo={} 
                    if(this.state.globalUser==true) fireInfo['users/' +this.state.clientID]=null
                    else fireInfo['usersListClients/'+getAuth(firebase).currentUser.uid+'/'+this.state.clientID]=null

                    update(ref(getDatabase(firebase)), fireInfo)
                  
                }
                
                
                this.alert.onAlert({title:strings.removeClientOK,buttons:[{text:strings.ok,onPress: () => {if( this.props.navigation!=undefined)this.props.navigation.dispatch(CommonActions.reset({index: 0,routes: [{ name: 'Main' },],}) ); else {console.log("ici"); this.props.params.resetNavigation(); }    }} ],});
                

              }
              else{


                var sendToFirebase=(this.state.accountClientDisabled==true)?false:true;
                const fireInfo={} 
                fireInfo['users/' +this.state.clientID]={accountClientDisabled:sendToFirebase}
                update(ref(getDatabase(firebase)), fireInfo)

                this.alert.onAlert({title:(sendToFirebase==false)?strings.accountHasBeenEnabled:strings.accountHasBeenDisabled, buttons:[{text:strings.ok,onPress: () => { 
                    if( this.props.navigation!=undefined) this.props.navigation.dispatch(CommonActions.reset({index: 0,routes: [{ name: 'Main' },],}) );
                    else this.props.params.resetNavigation();
                 }}]  

                })
                



              }
                
            }
            else {this.setState({viewMode:"removeAccount"});} }}/>
            </View>}

      
      {(Platform.OS!="web" && this.state.createAccount!=true && this.state.newClient!=true && this.state.adminView!=true && info.appliVersion!=undefined) && <Text style={{marginTop:10,color: style.textInputColor,fontSize: style.textInputFontSize*0.7,textAlign: "center",}}>{strings.appliVersion+" : "+info.appliVersion} {(this.state.appliLastVersion==info.appliVersion) && <Text>{"\n"+strings.appliVersionOK}</Text>} </Text>}

      </View>}

      

      {(this.state.adminView==true && this.state.admin==true) && <TouchableHighlight underlayColor="rgba(0,0,0,0)" onPress={() => {  Clipboard.setString(this.state.clientID);this.alert.onAlert({title:strings.copiedClipboard}); }}>
            <Text style={{marginTop:15,marginBottom:15, color: style.textInputColor,fontSize: style.textInputFontSize*0.7,textAlign: "center",bottom:20, }}>{strings.ifProblemeMAV+"\n"+this.state.clientID}</Text>
      </TouchableHighlight>}




      {(this.state.viewMode=="changePassword" || this.state.viewMode=="removeAccount") && <View style={{}} >
      <Text style={{marginTop:15,color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center"}}>{(this.state.viewMode=="changePassword")?strings.changePassword:strings.account}</Text>
              
      {this.state.viewMode=="removeAccount" && <Text style={{marginTop:20,marginLeft:"10%", marginRight:"10%",color: style.textInputColor,fontSize: style.textInputFontSize,textAlign: "center",}}>{strings.yourPasswordObligatory}</Text>}

      <MavTextInput style={{marginTop:15}} secureTextEntry={true} enableViewPassword={true} editable={(this.state.waiting==false && this.state.disabledChange==false) }  textInputFlex={0.8} text={this.state.old} textExplication={(this.state.removeAccount==true)?strings.password:strings.oldPassword} placeholder={"********"} onChangeText={(text)=>{this.setState({old:text})}}/>
      {this.state.viewMode=="changePassword" && <MavTextInput style={{marginTop:5}}  enableViewPassword={true} secureTextEntry={true} textInputFlex={2} text={this.state.password} textExplicationMini={strings.learnMore} textExplicationOnPress={() => {this.alert.onAlert({title:strings.passwordMoreInfo}) }} editable={(this.state.waiting==false && this.state.disabledChange==false) }  textInputFlex={0.8} text={this.state.new} textExplication={strings.newPassword} placeholder={"********"} onChangeText={(text)=>{this.setState({new:text})}}/>}

      <View style={{alignItems:"center",justifyContent:"center", marginTop:30}}> 
          <MavButton onlyButton={true} text={strings.confirm} onPress={()=>{ this.updatePassRemoveAccount() }} />
      </View>

      <View style={{alignItems:"center",justifyContent:"center", marginTop:15}}> 
          <MavButton onlyButton={true} strokeMode={true} text={strings.cancel} onPress={()=>{ this.setState({viewMode:"normal"})}} />
      </View>


      </View>}


      <MavAlert ref={alert => {this.alert = alert;}}/>

              

            
            <Modal
              animationType="slide"
              transparent={false}
              visible={(this.state.viewTrajet==true)}>
              <View style={{flex: 1,backgroundColor: style.backgroundColor}}>
                  <Trajet params={{  goBack:() => {this.setState({viewTrajet:false}); }, onFavoritePlace: this.onFavoritePlace }}/>
              </View>
            
            </Modal>

          <Modal
        animationType="slide"
        transparent={false}
        visible={this.state.carModalVisible}>
        <View style={{flex: 1,backgroundColor: style.backgroundColor}}>
                        
              <View style={{marginTop: 50,backgroundColor:style.backgroundColor}}>
                    <MavTextInput style={{marginTop:5}} textInputFlex={2} editable={(this.state.waiting==false && this.state.disabledChange==false) }  text={this.state.car.brand} textExplication={strings.brand} placeholder={"Peugeot"} onChangeText={(text)=>{var car=this.state.car;car.brand=text;this.setState({car:car})}}/>
                    <MavTextInput style={{marginTop:5}} textInputFlex={2} editable={(this.state.waiting==false && this.state.disabledChange==false) }  text={this.state.car.model} textExplication={strings.model} placeholder={"508"} onChangeText={(text)=>{var car=this.state.car;car.model=text;this.setState({car:car})}}/>
                    <MavTextInput style={{marginTop:5}} textInputFlex={2} editable={(this.state.waiting==false && this.state.disabledChange==false) }  text={this.state.car.immatriculation} textExplication={strings.immatriculation} placeholder={"VT-123-CM"} onChangeText={(text)=>{var car=this.state.car;car.immatriculation=text;this.setState({car:car})}}/>
                    {info.countryCode=="lux" && <MavTextInput style={{marginTop:5}} textInputFlex={2} editable={(this.state.waiting==false && this.state.disabledChange==false) }  text={this.state.car.chassis} textExplication={strings.chassis} placeholder={"AR3X3RZB2YYT4422Y64"} onChangeText={(text)=>{var car=this.state.car;car.chassis=text;this.setState({car:car})}}/>}

                    <MavButton text={strings.validate} style={{marginTop:40}} onPress={()=>{ 
                        var cm=this.state.carModel;
                        if(this.state.carID=="") cm[Object.keys(cm).length]=this.state.car;
                        else cm[this.state.carID]=this.state.car;
                        this.setState({carModalVisible:false,carModal:cm})
                     }}/>


                    <MavButton text={strings.cancel} strokeMode={true} style={{marginTop:10}} onPress={()=>{ 
                        this.setState({carModalVisible:false})
                     }}/>

              </View>

          </View>

          </Modal>

          {(this.state.viewClients==true) && <Modal
              animationType="slide"
              transparent={true}
              visible={this.state.viewClients==true}>
              <View style={{flex:1, backgroundColor:"rgba(0,0,0,0.5)", alignItems:"center", justifyContent:"center"}}>
                <View style={{width:(Dimensions.get('window').width>style.mobileSizeMax)?style.mobileSizeMax*0.75:"100%", height:(Dimensions.get('window').width>style.mobileSizeMax)?"90%":"100%",backgroundColor: style.backgroundColor}}>
                          
                  <Clients close={()=>{ console.log("close"); this.setState({viewClients:false})}} params={{forceGlobalUser:this.state.clientID}} />

                </View>
              </View>

          </Modal>}



          {(this.state.viewPicture==true) && <Modal
        animationType="slide"
        transparent={false}
        visible={this.state.viewPicture==true}>
        <View style={{flex: 1,backgroundColor: style.backgroundColor}}>
                        
              <View style={{marginTop: 50,backgroundColor:style.backgroundColor,flex:1}}>
                    
                    <Image source={require('../assets/userBlank.png')} style={{ resizeMode:"contain", marginLeft:((Dimensions.get('window').width>Dimensions.get('window').height)?((Dimensions.get('window').width-Dimensions.get('window').height*0.7)/2):Dimensions.get('window').width*0.15), width:((Dimensions.get('window').width>Dimensions.get('window').height)?Dimensions.get('window').height*0.7:Dimensions.get('window').width*0.7)    , height:((Dimensions.get('window').width>Dimensions.get('window').height)?Dimensions.get('window').height*0.7:Dimensions.get('window').width*0.7),position:"absolute" }}/>
                    <Image source={{uri:"https://firebasestorage.googleapis.com/v0/b/"+info.firebaseProjectID+".appspot.com/o/partners%2F"+this.state.clientID+"%2Fpicture.jpg?alt=media"}} style={{borderRadius:(Platform.OS=="web")?"50%":((Dimensions.get('window').width>Dimensions.get('window').height)?Dimensions.get('window').height*0.35:Dimensions.get('window').width*0.35), marginLeft:((Dimensions.get('window').width>Dimensions.get('window').height)?((Dimensions.get('window').width-Dimensions.get('window').height*0.7)/2):Dimensions.get('window').width*0.15), width:((Dimensions.get('window').width>Dimensions.get('window').height)?Dimensions.get('window').height*0.7:Dimensions.get('window').width*0.7)    , height:((Dimensions.get('window').width>Dimensions.get('window').height)?Dimensions.get('window').height*0.7:Dimensions.get('window').width*0.7),position:"absolute" }}/>
                      
                   <View style={{position:"absolute", marginTop:Dimensions.get('window').height*0.8}}>
                      <MavButton text={strings.close} strokeMode={true} onPress={()=>{ 
                          this.setState({viewPicture:false})
                       }}/>
                  </View>

              </View>

          </View>

          </Modal>}



              {this.state.waitingPicture===true && <View style={{alignItems:"center",justifyContent:"center",position: 'absolute',height:Dimensions.get('window').height, width:Dimensions.get('window').width,backgroundColor:style.backgroundColor}}> 
                  <ActivityIndicator style={{marginTop:-100}} size="large" color={style.color1} /> 
                  <Text allowFontScaling={false} style={{fontSize:style.textInputFontSize,marginTop:5,color:style.textInputColor}}>{strings.thankWaiting}</Text>
          </View>}


      </ScrollView>


      }</StyleContext.Consumer>

    );
  }
}



export function generateUUID() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}


